(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["family-hub-comparison-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /**
     * Liquid is not evaluated in theme javascript assets — config is injected via
     * script[type="application/json"][data-fh-product-config] next to each .fh-page root.
     */
    const FH_DEBUG = true;
    const fhLog = (...args) => {
      if (FH_DEBUG) console.log('[FamilyHubProduct]', ...args);
    };

    function initFamilyHubProduct(root, cfg) {
      const sectionId = cfg.sectionId;
      const productFormId = cfg.productFormId;
      const variants = cfg.variants;
      const sizeOptIndex = cfg.sizeOptIndex;
      let selectedSize = cfg.initialSize;
      let selectedVariantId = cfg.initialVariantId;
      const subVariantId = cfg.subVariantId;
      const subSellingPlanId = cfg.subSellingPlanId;
      const bundleSkuBySize = cfg.bundleSkuBySize || {};
      const MAX_FH_DEVICES =
        typeof window.FH_MAX_FAMILY_HUB_DEVICES === 'number' ? window.FH_MAX_FAMILY_HUB_DEVICES : 5;

      const sizeCards = root.querySelectorAll('.fh-size-card');
      const planCards = root.querySelectorAll('.fh-plan-card');
      const atcBtn = root.querySelector('[data-plan-atc]');
      // Plan card prices are derived from variant.price ± discountCents
      // (custom.byg_discount_cents on the variant, else the product). See syncVariant().
      const planWithPriceEl = root.querySelector('[data-fh-plan-with-price]');
      const planWithCompareEl = root.querySelector('[data-fh-plan-with-compare]');
      const planWithTaglineEl = root.querySelector('[data-fh-plan-with-tagline]');
      // Annual-plan badge target span. Distinct from the size cards' data-fh-plan-pill
      // (the data source) so this selector can't accidentally match a size card.
      const planWithPillEl = root.querySelector('[data-fh-plan-pill-target]');
      const planWithoutPriceEl = root.querySelector('[data-fh-plan-without-price]');
      const planWithoutCompareEl = root.querySelector('[data-fh-plan-without-compare]');
      const discountCents = Math.max(0, Number(cfg.discountCents) || 0);
      // Per-variant amounts from custom.byg_discount_cents on the variant; a
      // variant with no value of its own falls back to the product-level one.
      const discountCentsBySku = cfg.discountCentsBySku || {};
      const discountCentsFor = (sku) => {
        const key = String(sku || '').toUpperCase();
        // A present key is authoritative even at 0 — that is a variant
        // deliberately excluded from the discount. Only an unknown SKU falls
        // back to the amount rendered on load.
        if (Object.prototype.hasOwnProperty.call(discountCentsBySku, key)) {
          const mapped = Number(discountCentsBySku[key]);
          if (Number.isFinite(mapped)) return Math.max(0, mapped);
        }
        return discountCents;
      };
      // Restricting discounts: [{ code, cents }] — cents is the device-only
      // discount shown on the PDP when THAT code is applied. Multiple codes with
      // different amounts are supported (e.g. F2H60-GL $30, 86JAX3JML0D7 $50).
      const restrictingDiscounts = (Array.isArray(cfg.restrictingDiscounts) ? cfg.restrictingDiscounts : [])
        .map(function (e) {
          return {
            code: String((e && e.code) || '').trim().toUpperCase(),
            cents: Math.max(0, Number(e && e.cents) || 0),
          };
        })
        .filter(function (e) { return e.code; });
      // Backward-compat: fall back to legacy single-code config if list is empty.
      if (!restrictingDiscounts.length) {
        const legacyCode = String(cfg.restrictingDiscountCode || '').trim().toUpperCase();
        if (legacyCode) {
          restrictingDiscounts.push({ code: legacyCode, cents: Math.max(0, Number(cfg.restrictingDiscountCents) || 0) });
        }
      }
      const restrictingCodes = restrictingDiscounts.map(function (e) { return e.code; });
      let activeRestrictingCents = 0; // cents of the restricting code currently on the cart (0 = none)
      let activeRestrictingCode = ''; // upper-case code currently on the cart ('' = none)
      const productForm = productFormId ? document.forms[productFormId] : undefined;
      const planWithAnnualCard = root.querySelector('[data-fh-plan-with-annual]');
      const restrictingHelperEl = root.querySelector('[data-fh-restricting-helper]');
      const planPickerEl = root.querySelector('[data-fh-plan-picker]');
      const planPickerLabelEl = root.querySelector('[data-fh-plan-picker-label]');
      const planWithoutTitleDefaultEl = root.querySelector('[data-fh-plan-without-title-default]');
      const planWithoutTitleRestrictingEl = root.querySelector('[data-fh-plan-without-title-restricting]');
      const planWithoutBodyDefaultEl = root.querySelector('[data-fh-plan-without-body-default]');
      const planWithoutBodyRestrictingEl = root.querySelector('[data-fh-plan-without-body-restricting]');
      const planWithoutHeaderRestrictingEl = root.querySelector('[data-fh-plan-without-header-restricting]');
      // Per-code override for the device-only restricting-card copy. Codes not
      // listed here keep the default markup ($30 body, no promo header), so
      // F2H60-GL is unaffected. headerHtml / bodyHtml are trusted theme-authored
      // strings, safe to assign as innerHTML.
      const RESTRICTING_COPY = {
        '86JAX3JML0D7': {
          headerHtml: 'NOW <s>$30</s> $50 off — LIMITED TIME OFFER ENDS 7/31.',
          bodyHtml:
            "As an existing Greenlight customer, for a limited time you'll get $50 off the purchase of your first Family Hub and the chance to enjoy all premium Family Hub+ features through this exclusive offer link.",
        },
      };
      const defaultRestrictingBodyHtml = planWithoutBodyRestrictingEl
        ? planWithoutBodyRestrictingEl.innerHTML
        : '';
      let annualPlanRestricted = false;

      if (restrictingCodes.length) {
        window.FH_RESTRICTING_DISCOUNT_CODES = restrictingCodes.slice();
        window.FH_RESTRICTING_DISCOUNT_CODE = restrictingCodes[0]; // legacy single-code global
      }

      // Returns the matched { code, cents } entry for the restricting code applied
      // to the cart, or null if none is applied.
      function matchedRestrictingDiscount(cart) {
        if (!restrictingDiscounts.length || !cart) return null;
        const applied = cart.discount_codes || [];
        for (let i = 0; i < applied.length; i++) {
          const entry = applied[i];
          if (!entry || !entry.code) continue;
          const code = String(entry.code).trim().toUpperCase();
          for (let j = 0; j < restrictingDiscounts.length; j++) {
            if (restrictingDiscounts[j].code === code) return restrictingDiscounts[j];
          }
        }
        return null;
      }

      function cartHasRestrictingDiscountCode(cart) {
        return !!matchedRestrictingDiscount(cart);
      }

      function applyAnnualPlanRestriction(restricted) {
        annualPlanRestricted = restricted;
        if (planPickerEl) {
          planPickerEl.classList.toggle('fh-plan-picker--restricted', restricted);
        }
        if (planPickerLabelEl) {
          if (restricted) planPickerLabelEl.setAttribute('hidden', '');
          else planPickerLabelEl.removeAttribute('hidden');
        }
        if (planWithoutTitleDefaultEl) {
          if (restricted) planWithoutTitleDefaultEl.setAttribute('hidden', '');
          else planWithoutTitleDefaultEl.removeAttribute('hidden');
        }
        if (planWithoutTitleRestrictingEl) {
          if (restricted) planWithoutTitleRestrictingEl.removeAttribute('hidden');
          else planWithoutTitleRestrictingEl.setAttribute('hidden', '');
        }
        if (planWithoutBodyDefaultEl) {
          if (restricted) planWithoutBodyDefaultEl.setAttribute('hidden', '');
          else planWithoutBodyDefaultEl.removeAttribute('hidden');
        }
        if (planWithoutBodyRestrictingEl) {
          if (restricted) {
            const copy = RESTRICTING_COPY[activeRestrictingCode] || null;
            planWithoutBodyRestrictingEl.innerHTML = copy ? copy.bodyHtml : defaultRestrictingBodyHtml;
            planWithoutBodyRestrictingEl.removeAttribute('hidden');
            if (planWithoutHeaderRestrictingEl) {
              if (copy && copy.headerHtml) {
                planWithoutHeaderRestrictingEl.innerHTML = copy.headerHtml;
                planWithoutHeaderRestrictingEl.removeAttribute('hidden');
              } else {
                planWithoutHeaderRestrictingEl.setAttribute('hidden', '');
              }
            }
          } else {
            planWithoutBodyRestrictingEl.setAttribute('hidden', '');
            planWithoutBodyRestrictingEl.innerHTML = defaultRestrictingBodyHtml;
            if (planWithoutHeaderRestrictingEl) planWithoutHeaderRestrictingEl.setAttribute('hidden', '');
          }
        }
        if (planWithAnnualCard) {
          planWithAnnualCard.classList.toggle('fh-plan-card--annual-restricted', restricted);
          if (restricted) {
            planWithAnnualCard.setAttribute('aria-hidden', 'true');
            planWithAnnualCard.classList.remove('is-selected');
            planWithAnnualCard.setAttribute('aria-checked', 'false');
            planWithAnnualCard.tabIndex = -1;
          } else {
            planWithAnnualCard.removeAttribute('aria-hidden');
          }
        }
        if (restrictingHelperEl) {
          restrictingHelperEl.setAttribute('hidden', '');
        }
        if (restricted && isWithPlan(selectedPlan)) {
          selectedPlan = PLAN_BUNDLE_DEVICE_ONLY;
          planCards.forEach((item) => {
            const active = item.dataset.planValue === selectedPlan;
            const hidden = item.classList.contains('fh-plan-card--annual-restricted');
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-checked', String(active));
            if (!hidden) item.tabIndex = active ? 0 : -1;
          });
          syncVariant({ dispatchGalleryEvent: false });
          placeAtcButton();
        } else {
          syncVariant({ dispatchGalleryEvent: false });
        }
      }

      function refreshRestrictingDiscountUi(cart) {
        const matched = matchedRestrictingDiscount(cart);
        activeRestrictingCents = matched ? matched.cents : 0;
        activeRestrictingCode = matched ? matched.code : '';
        applyAnnualPlanRestriction(!!matched);
      }

      function familyHubDevicesInCart(cart) {
        if (typeof window.fhFamilyHubDeviceCount === 'function') {
          return window.fhFamilyHubDeviceCount(cart);
        }
        var items = (cart && cart.items) || [];
        var n = 0;
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (!it || !it.requires_shipping || !it.sku) continue;
          if (it.sku === 'GLH10' || it.sku === 'GLH15') n += it.quantity || 0;
        }
        return n;
      }

      function fhCartJsonUrl() {
        try {
          if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
            return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
          }
        } catch (_) {}
        return '/cart.js';
      }

      // Locale-safe cart PAGE url (not /cart.js) — used to redirect after ATC.
      function fhCartPageUrl() {
        try {
          if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
            return window.theme.routes.cart_url;
          }
        } catch (_) {}
        return '/cart';
      }
      // No setTimeout debounce: rapid cart:updated / pubsub bursts (drawer remove,
      // orphan sub flush) kept resetting the timer so the PDP never updated until
      // the tab went to background (timer coalescing). fh-cart-sync also syncs
      // `[data-plan-atc]` synchronously from event cart JSON; this fetch is backup.
      function refreshFhDeviceCapUi() {
        var capUrl = fhCartJsonUrl();
        capUrl += (capUrl.indexOf('?') >= 0 ? '&' : '?') + 'fh_cap=' + Date.now();
        fetch(capUrl, { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            refreshRestrictingDiscountUi(cart);
            var n = familyHubDevicesInCart(cart);
            if (!atcBtn) return;
            var atCap = n >= MAX_FH_DEVICES;
            if (atCap) {
              atcBtn.disabled = true;
              atcBtn.setAttribute('data-fh-device-cap-reached', 'true');
            } else {
              atcBtn.removeAttribute('data-fh-device-cap-reached');
              try {
                atcBtn.removeAttribute('aria-disabled');
              } catch (_) {}
              atcBtn.disabled = false;
              syncVariant({ dispatchGalleryEvent: false });
            }
          })
          .catch(function () {});
      }

      function bindFhDeviceCapCartListeners() {
        if (!window.__fhFamilyHubCapRefreshers) {
          window.__fhFamilyHubCapRefreshers = [];
        }
        window.__fhFamilyHubCapRefreshers.push(refreshFhDeviceCapUi);
        if (!window.__fhFamilyHubCartCapListenersBound) {
          window.__fhFamilyHubCartCapListenersBound = true;
          var runAllCapRefreshers = function () {
            (window.__fhFamilyHubCapRefreshers || []).forEach(function (fn) {
              try {
                fn();
              } catch (eFn) {}
            });
          };
          document.addEventListener('cart:updated', runAllCapRefreshers);
          // Drawer empty-state re-renders after fh-cart-sync orphan flush use
          // cart:refresh; cart:updated can miss the final empty cart in some races.
          document.addEventListener('cart:refresh', runAllCapRefreshers);
          try {
            if (
              window.theme &&
              window.theme.pubsub &&
              window.theme.pubsub.PUB_SUB_EVENTS &&
              typeof window.theme.pubsub.subscribe === 'function'
            ) {
              window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, runAllCapRefreshers);
            }
          } catch (_) {}
        }
      }

      /** Bundle choice only (not tied to size option index). Matches data-plan-value on plan cards. */
      const PLAN_BUNDLE_WITH_SUBSCRIPTION = 'With Annual Plan';
      const PLAN_BUNDLE_DEVICE_ONLY = 'Without Annual Plan';
      let selectedPlan = PLAN_BUNDLE_WITH_SUBSCRIPTION;

    const money = (cents) => `$${(cents / 100).toFixed(2)}`;
    const isWithPlan = (planValue) => planValue === PLAN_BUNDLE_WITH_SUBSCRIPTION;
    const placeAtcButton = () => {
      if (!atcBtn) return;
      const anchorSel = isWithPlan(selectedPlan)
        ? '[data-atc-anchor="featured"]'
        : '[data-atc-anchor="compact"]';
      const anchor = root.querySelector(anchorSel);
      if (anchor && atcBtn.parentElement !== anchor) anchor.appendChild(atcBtn);
      root.querySelectorAll('[data-atc-anchor].fh-plan-atc-anchor--slot').forEach((el) => {
        el.classList.toggle('fh-plan-atc-anchor--inactive', !el.contains(atcBtn));
      });
    };
    const optionKeyForSize = () =>
      sizeOptIndex === null ? null : `option${Number(sizeOptIndex) + 1}`;

    const getVariant = (size) => {
      if (sizeOptIndex === null) return variants[0];
      const optionKey = optionKeyForSize();
      return variants.find((variant) => variant[optionKey] === size);
    };

    const getVariantById = (id) => variants.find((v) => Number(v.id) === Number(id));

    /**
     * @param {{ dispatchGalleryEvent?: boolean }} [opts]
     *   dispatchGalleryEvent — when false, skip `variant:change` on the product form so the
     *   main media gallery stays on the server-rendered hero (first catalog image with
     *   pin_first_media). Family Hub calls this with false only for the initial sync; any
     *   user-driven update (size, plan, etc.) dispatches so MediaGallery can follow the variant.
     */
    const syncVariant = (opts) => {
      opts = opts || {};
      const dispatchGalleryEvent = opts.dispatchGalleryEvent !== false;
      const byId = getVariantById(selectedVariantId);
      const bySize = getVariant(selectedSize);
      const fallback = variants[0];
      const variant = byId || bySize || fallback;
      let resolvedVia = 'none';
      if (variant) {
        if (byId && variant.id === byId.id) resolvedVia = 'selectedVariantId';
        else if (bySize && variant.id === bySize.id) resolvedVia = 'selectedSize string match';
        else if (fallback && variant.id === fallback.id) resolvedVia = 'variants[0] fallback';
      }
      fhLog('syncVariant()', {
        resolvedVia,
        selectedVariantId,
        selectedSize,
        selectedPlan,
        variantFound: !!variant,
        variantId: variant?.id,
        optionKey: optionKeyForSize(),
        variantOptions: variant
          ? {
              option1: variant.option1,
              option2: variant.option2,
              option3: variant.option3,
            }
          : null,
        productFormFound: !!productForm,
      });
      if (!variant) {
        fhLog('syncVariant() aborted — no variant');
        return;
      }
      selectedVariantId = variant.id;
      const ok = optionKeyForSize();
      if (ok) selectedSize = variant[ok];
      const variantPriceCents = Number(variant.price) || 0;
      const variantDiscountCents = discountCentsFor(variant.sku);
      const withPlanCents = Math.max(0, variantPriceCents - variantDiscountCents);
      const variantFormatted = money(variantPriceCents);
      const withPlanFormatted = money(withPlanCents);
      if (planWithPriceEl) planWithPriceEl.textContent = withPlanFormatted;
      if (planWithoutPriceEl) {
        if (annualPlanRestricted && activeRestrictingCents > 0) {
          const restrictedCents = Math.max(0, variantPriceCents - activeRestrictingCents);
          planWithoutPriceEl.textContent = money(restrictedCents);
        } else {
          planWithoutPriceEl.textContent = variantFormatted;
        }
      }
      if (planWithoutCompareEl) {
        if (annualPlanRestricted && activeRestrictingCents > 0) {
          planWithoutCompareEl.textContent = variantFormatted;
          planWithoutCompareEl.removeAttribute('hidden');
        } else {
          planWithoutCompareEl.textContent = '';
          planWithoutCompareEl.setAttribute('hidden', '');
        }
      }
      if (planWithCompareEl) {
        if (variantDiscountCents > 0) {
          planWithCompareEl.textContent = variantFormatted;
          planWithCompareEl.removeAttribute('hidden');
        } else {
          planWithCompareEl.textContent = '';
          planWithCompareEl.setAttribute('hidden', '');
        }
      }
      if (planWithTaglineEl) {
        const tpl = planWithTaglineEl.dataset.fhTaglineTemplate || '';
        if (tpl.indexOf('{price}') >= 0) {
          planWithTaglineEl.textContent = tpl.replace(/\{price\}/g, withPlanFormatted);
        }
      }
      // Badge follows the selected size: read data-fh-plan-pill off the active size
      // card (matched by variant id, falling back to size value — same rule as the
      // is-selected toggle). Hide the badge when the selected size defines none.
      if (planWithPillEl) {
        let activeSizeCard = null;
        sizeCards.forEach((item) => {
          const itemVid = Number(item.dataset.variantId || 0);
          const isActive = itemVid ? itemVid === Number(selectedVariantId) : item.dataset.sizeValue === selectedSize;
          if (isActive) activeSizeCard = item;
        });
        const pillText = activeSizeCard ? (activeSizeCard.getAttribute('data-fh-plan-pill') || '').trim() : '';
        if (pillText) {
          planWithPillEl.textContent = pillText;
          planWithPillEl.removeAttribute('hidden');
        } else {
          planWithPillEl.setAttribute('hidden', '');
        }
      }
      if (atcBtn) {
        atcBtn.dataset.variantId = variant.id;
        atcBtn.dataset.planValue = selectedPlan;
        var invBlocked = !variant.available && variant.inventory_policy !== 'continue';
        if (invBlocked) atcBtn.setAttribute('data-fh-inventory-blocked', 'true');
        else atcBtn.removeAttribute('data-fh-inventory-blocked');
        atcBtn.disabled = invBlocked || atcBtn.getAttribute('data-fh-device-cap-reached') === 'true';
      }
      if (productForm) {
        const idInput = productForm.querySelector('input[name="id"]');
        if (idInput) idInput.value = String(variant.id);
        if (dispatchGalleryEvent) {
          productForm.dispatchEvent(
            new CustomEvent('variant:change', {
              bubbles: true,
              detail: { variant },
            })
          );
        }
      }
    };

    fhLog('init', {
      sectionId,
      sizeCards: sizeCards.length,
      planCards: planCards.length,
      sizeOptIndex,
      initialSelectedSize: selectedSize,
      initialSelectedVariantId: selectedVariantId,
      sizeCardSnapshots: Array.from(sizeCards).map((el, i) => ({
        index: i,
        variantId: el.dataset.variantId || null,
        sizeValueAttr: el.getAttribute('data-size-value'),
        datasetSizeValue: el.dataset.sizeValue,
      })),
      variantSnapshots: variants.map((v) => ({
        id: v.id,
        option1: v.option1,
        option2: v.option2,
        option3: v.option3,
        available: v.available,
      })),
    });

    sizeCards.forEach((card) => {
      card.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const t = e.target;
        fhLog('size click', {
          target: { tag: t.tagName, className: t.className },
          cardDataset: { variantId: card.dataset.variantId, sizeValue: card.dataset.sizeValue },
          rawAttr: card.getAttribute('data-size-value'),
        });
        const vid = Number(card.dataset.variantId || 0);
        const byId = vid ? getVariantById(vid) : null;
        if (byId) {
          selectedVariantId = byId.id;
          const ok = optionKeyForSize();
          if (ok) selectedSize = byId[ok];
          fhLog('size → resolved by variant id', { vid, selectedVariantId, selectedSize, byIdOption: ok ? byId[ok] : null });
        } else {
          selectedSize = card.dataset.sizeValue || selectedSize;
          const v = getVariant(selectedSize);
          if (v) selectedVariantId = v.id;
          fhLog('size → fallback string path', {
            selectedSize,
            getVariantHit: !!v,
            selectedVariantId,
          });
        }
        sizeCards.forEach((item) => {
          const itemVid = Number(item.dataset.variantId || 0);
          const active = itemVid ? itemVid === Number(selectedVariantId) : item.dataset.sizeValue === selectedSize;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-checked', String(active));
        });
        fhLog('size UI after toggle', {
          selectedVariantId,
          selectedSize,
          selectedClasses: Array.from(sizeCards).map((el) => ({
            vid: el.dataset.variantId,
            isSelected: el.classList.contains('is-selected'),
          })),
        });
        syncVariant({ dispatchGalleryEvent: false });
      });
    });

    planCards.forEach((card, planIndex) => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('.fh-atc')) {
          fhLog('plan click ignored (ATC)', { planIndex, target: e.target.tagName });
          return;
        }
        if (
          annualPlanRestricted &&
          card.dataset.planValue === PLAN_BUNDLE_WITH_SUBSCRIPTION
        ) {
          return;
        }
        e.stopPropagation();
        const prevPlan = selectedPlan;
        selectedPlan = card.dataset.planValue || selectedPlan;
        fhLog('plan click', {
          planIndex,
          target: { tag: e.target.tagName, className: e.target.className },
          cardDatasetPlan: card.dataset.planValue,
          prevPlan,
          nextPlan: selectedPlan,
          selectedVariantId,
          selectedSize,
        });
        planCards.forEach((item) => {
          const active = item.dataset.planValue === selectedPlan;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-checked', String(active));
        });
        syncVariant({ dispatchGalleryEvent: false });
        placeAtcButton();
      });
    });

    /** Compare SellingPlan ids from cart.js vs Liquid-injected GID or numeric id. */
    function normalizeSellingPlanId(id) {
      if (id == null || id === '') return '';
      return String(id).replace(/^gid:\/\/shopify\/SellingPlan\//i, '');
    }

    /** True if this cart line is the annual plan variant + same selling plan as PDP. */
    function cartLineMatchesPlanSub(line, subVid, planId) {
      if (Number(line.variant_id) !== Number(subVid)) return false;
      if (!planId) return !line.selling_plan_allocation;
      const sp = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
      if (!sp || sp.id == null) return false;
      return normalizeSellingPlanId(sp.id) === normalizeSellingPlanId(planId);
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', () => {
        const variantId = Number(atcBtn.dataset.variantId || 0);
        fhLog('ATC click', {
          variantId,
          atcDatasetPlan: atcBtn.dataset.planValue,
          selectedPlan,
          selectedVariantId,
          selectedSize,
          subVariantId,
          subSellingPlanId,
        });
        if (!variantId) return;

        const runAtc = () => {
        const withPlan = isWithPlan(atcBtn.dataset.planValue);
        const bundleSku = withPlan ? bundleSkuBySize[selectedSize] : null;

        // When adding the bundle, both the device line AND the subscription
        // line are stamped with the same `_bundle_parent_sku` line item
        // property. That property is the grouping key consumed downstream by:
        //   • cart-drawer.liquid / main-cart.liquid (visual merge)
        //   • snippets/fh-cart-sync.liquid (stepper/orphan sync)
        //   • extensions/subscription-zero-price (per-bundle Annual Plan
        //     discount via attribute(key:"_bundle_parent_sku") in its query)
        // If the size doesn't have a mapping (new size, or device-only ATC),
        // we add the lines without the property and the cart shows them as
        // standalone — the discount Function and visual merge both fail
        // open in that case.
        const bundleProperties = bundleSku
          ? { _bundle_parent_sku: bundleSku }
          : null;

        const deviceLine = { id: variantId, quantity: 1 };
        if (bundleProperties) deviceLine.properties = bundleProperties;
        const items = [deviceLine];

        if (withPlan && subVariantId) {
          const subLine = { id: subVariantId, quantity: 1 };
          if (subSellingPlanId) subLine.selling_plan = subSellingPlanId;
          if (bundleProperties) subLine.properties = bundleProperties;
          items.push(subLine);
        }

        fhLog('ATC /cart/add.js payload', { items });

        const originalLabel = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';

        const finishSuccess = (cart) => {
          atcBtn.textContent = originalLabel;
          atcBtn.disabled = false;
          syncVariant({ dispatchGalleryEvent: false });
          refreshFhDeviceCapUi();
          document.querySelectorAll('cart-count').forEach((countNode) => {
            const display =
              typeof window.fhCartDisplayItemCount === 'function'
                ? window.fhCartDisplayItemCount(cart)
                : cart.item_count;
            countNode.textContent = String(display);
            countNode.toggleAttribute('hidden', display === 0);
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          // Take the shopper to the cart page instead of relying on a drawer.
          window.location.href = fhCartPageUrl();
        };

        const finishError = () => {
          atcBtn.textContent = 'Try again';
          atcBtn.disabled = false;
          setTimeout(() => {
            atcBtn.textContent = originalLabel;
            syncVariant({ dispatchGalleryEvent: false });
          }, 1200);
        };

        /** Single /cart/add.js then fresh cart (first plan bundle, or device-only). */
        const addItemsThenCart = (payloadItems) =>
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: payloadItems }),
          })
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then(() => fetch(fhCartJsonUrl()))
            .then((response) => response.json());

        // Device-only / plan without sub variant: one add.
        if (!withPlan || !subVariantId) {
          addItemsThenCart(items).then(finishSuccess).catch(finishError);
          return;
        }

        // With plan: reuse single subscription line when already in cart.
        fetch(fhCartJsonUrl())
          .then((response) => response.json())
          .then((cart) => {
            const existingSub = (cart.items || []).find((line) =>
              cartLineMatchesPlanSub(line, subVariantId, subSellingPlanId)
            );

            if (!existingSub) {
              fhLog('ATC first plan bundle — device + sub');
              return addItemsThenCart(items);
            }

            fhLog('ATC extra plan bundle — device only (subscription stays qty 1)', {
              subKey: existingSub.key,
            });

            const deviceOnly = [deviceLine];
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: deviceOnly }),
            })
              .then((response) => {
                if (!response.ok) return Promise.reject(response);
                return response.json();
              })
              .then(() => fetch(fhCartJsonUrl()).then((r) => r.json()));
          })
          .then(finishSuccess)
          .catch(finishError);
        };

        fetch(fhCartJsonUrl())
          .then((r) => r.json())
          .then((cart) => {
            if (familyHubDevicesInCart(cart) >= MAX_FH_DEVICES) {
              fhLog('ATC blocked — at Family Hub device limit');
              atcBtn.disabled = true;
              atcBtn.setAttribute('data-fh-device-cap-reached', 'true');
              return;
            }
            runAtc();
          })
          .catch(() => {
            runAtc();
          });
      });
    }

    // Mobile floating add-to-cart (Nike-style): proxies the real ATC button,
    // mirrors its label + disabled state, and hides whenever the real button is
    // visible in the viewport.
    const floatingAtc = root.querySelector('[data-fh-floating-atc]');
    if (floatingAtc && atcBtn) {
      const floatingLabel =
        floatingAtc.querySelector('[data-fh-floating-atc-label]') || floatingAtc;
      const syncFloatingAtc = () => {
        const label = (atcBtn.textContent || '').trim();
        if (label) floatingLabel.textContent = label;
        floatingAtc.disabled = atcBtn.disabled;
      };

      floatingAtc.addEventListener('click', () => {
        if (atcBtn.disabled) return;
        atcBtn.click();
      });

      // Mirror the real button's label ("Adding...", "Try again") and disabled
      // state (inventory-blocked / device-cap) without duplicating that logic.
      const labelObserver = new MutationObserver(syncFloatingAtc);
      labelObserver.observe(atcBtn, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });
      syncFloatingAtc();

      // Show the floating button only when the real ATC is off screen. The real
      // button moves between plan anchors, but observing the node itself is
      // unaffected by re-parenting.
      if ('IntersectionObserver' in window) {
        const atcVisibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              floatingAtc.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { root: null, threshold: 0 }
        );
        atcVisibilityObserver.observe(atcBtn);
      } else {
        floatingAtc.classList.add('is-visible');
      }
    }

    syncVariant({ dispatchGalleryEvent: false });
    placeAtcButton();
    bindFhDeviceCapCartListeners();
    refreshFhDeviceCapUi();
    }

    document.querySelectorAll('.fh-page[data-section-id]').forEach((root) => {
      const cfgEl = root.querySelector('script[type="application/json"][data-fh-product-config]');
      if (!cfgEl || !cfgEl.textContent.trim()) return;
      let cfg;
      try {
        cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        console.warn('[FamilyHubProduct] Invalid product config JSON', e);
        return;
      }
      initFamilyHubProduct(root, cfg);
    });

    /**
     * Hero video: swap the browser's native controls for a GL-designed play/pause
     * button (see website-next AtomicComponents/MediaControlButton). The gallery
     * <video> is injected by the theme's <video-media> element with controls:true;
     * we strip controls and mount our own persistent toggle in the bottom-right.
     * Both icons live in the button; the .fh-video--playing class on <video-media>
     * (driven by the video's play/pause events) swaps which one is visible.
     */
    const FH_PLAY_SVG =
      '<svg class="fh-video-toggle__play" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
    const FH_PAUSE_SVG =
      '<svg class="fh-video-toggle__pause" viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>';

    function fhMountVideoToggle(vm, video) {
      if (vm.__fhVideoToggle) return;
      vm.__fhVideoToggle = true;
      video.controls = false;
      video.removeAttribute('controls');

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fh-video-toggle';
      btn.innerHTML = FH_PLAY_SVG + FH_PAUSE_SVG;
      vm.appendChild(btn);

      const sync = () => {
        const playing = !video.paused && !video.ended;
        vm.classList.toggle('fh-video--playing', playing);
        btn.setAttribute(
          'aria-label',
          playing ? 'Pause video' : video.ended ? 'Play again' : 'Play video'
        );
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused || video.ended) {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } else {
          video.pause();
        }
      });
      sync();
    }

    function enhanceHeroVideo(root) {
      const gallery = root.querySelector('.fh-gallery');
      if (!gallery) return;
      gallery.querySelectorAll('video-media').forEach((vm) => {
        const existing = vm.querySelector('video');
        if (existing) {
          fhMountVideoToggle(vm, existing);
          return;
        }
        const obs = new MutationObserver(() => {
          const v = vm.querySelector('video');
          if (v) {
            obs.disconnect();
            fhMountVideoToggle(vm, v);
          }
        });
        obs.observe(vm, { childList: true, subtree: true });
      });
    }

    document.querySelectorAll('.fh-page[data-section-id]').forEach(enhanceHeroVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["family-hub-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /**
     * Liquid is not evaluated in theme javascript assets — config is injected via
     * script[type="application/json"][data-fh-product-config] next to each .fh-page root.
     */
    const FH_DEBUG = true;
    const fhLog = (...args) => {
      if (FH_DEBUG) console.log('[FamilyHubProduct]', ...args);
    };

    function initFamilyHubProduct(root, cfg) {
      const sectionId = cfg.sectionId;
      const productFormId = cfg.productFormId;
      const variants = cfg.variants;
      const sizeOptIndex = cfg.sizeOptIndex;
      let selectedSize = cfg.initialSize;
      let selectedVariantId = cfg.initialVariantId;
      let selectedVariantSku = ''; // upper-case SKU of the selected variant; scopes copy/badge lookup
      const subVariantId = cfg.subVariantId;
      const subSellingPlanId = cfg.subSellingPlanId;
      const bundleSkuBySize = cfg.bundleSkuBySize || {};
      const MAX_FH_DEVICES =
        typeof window.FH_MAX_FAMILY_HUB_DEVICES === 'number' ? window.FH_MAX_FAMILY_HUB_DEVICES : 5;

      const sizeCards = root.querySelectorAll('.fh-size-card');
      const planCards = root.querySelectorAll('.fh-plan-card');
      const atcBtn = root.querySelector('[data-plan-atc]');
      const expressBtn = root.querySelector('[data-fh-express-checkout]');
      // Plan card prices are derived from variant.price ± discountCents
      // (product.metafields.custom.byg_discount_cents). See syncVariant().
      const planWithPriceEl = root.querySelector('[data-fh-plan-with-price]');
      const planWithCompareEl = root.querySelector('[data-fh-plan-with-compare]');
      const planWithTaglineEl = root.querySelector('[data-fh-plan-with-tagline]');
      // Annual-plan badge target span. Distinct from the size cards' data-fh-plan-pill
      // (the data source) so this selector can't accidentally match a size card.
      const planWithPillEl = root.querySelector('[data-fh-plan-pill-target]');
      const planWithoutPriceEl = root.querySelector('[data-fh-plan-without-price]');
      const planWithoutCompareEl = root.querySelector('[data-fh-plan-without-compare]');
      const flashBadgeEl = root.querySelector('[data-fh-flash-badge]');
      const discountCents = Math.max(0, Number(cfg.discountCents) || 0);
      // Per-variant amounts from custom.byg_discount_cents on the variant, with
      // the product value already folded in as the fallback. A present key is
      // authoritative even at 0; only an unknown SKU falls back to the amount
      // rendered on load.
      const discountCentsBySku = cfg.discountCentsBySku || {};
      const discountCentsFor = (sku) => {
        const key = String(sku || '').toUpperCase();
        if (Object.prototype.hasOwnProperty.call(discountCentsBySku, key)) {
          const mapped = Number(discountCentsBySku[key]);
          if (Number.isFinite(mapped)) return Math.max(0, mapped);
        }
        return discountCents;
      };
      // Flash Sale — display-only, mirrors a real automatic discount (see
      // snippets/flash-sale-price.liquid for the equivalent Liquid-side lookup
      // used for the initial render). Keyed by SKU since product JSON fetched
      // here never reflects automatic discounts, unlike a restricting code
      // (which replaces this rather than stacking with it — see
      // restrictedDevicePriceCents()).
      const flashSaleOffers = (cfg && typeof cfg.flashSaleOffers === 'object' && cfg.flashSaleOffers) || {};
      function flashSaleDiscountedCents(trueCents, compareAtCents, sku) {
        const offer = flashSaleOffers[String(sku || '').toUpperCase()];
        if (!offer) return trueCents;
        const value = Number(offer.value) || 0;
        if (offer.valueType === 'cents') {
          return Math.max(0, trueCents - value);
        }
        if (offer.valueType === 'pct') {
          const base = Number(compareAtCents) > trueCents ? Number(compareAtCents) : trueCents;
          return Math.max(0, Math.round(base * (1 - value / 100)));
        }
        return trueCents;
      }
      // Restricting discounts: [{ code, cents, pct, variantSku }] — fixed cents
      // OR percent off the device shown on the PDP when THAT code is applied.
      // Multiple codes with different amounts are supported (e.g. F2H60-GL $30,
      // 86JAX3JML0D7 $50, 6HPCR8R78ZYX 15%). pct > 0 wins over cents.
      // variantSku scopes the PDP price rewrite to that one variant (blank ⇒
      // every variant of this product, matching every legacy offer entry).
      // Same code/prefix may appear more than once with different variantSku
      // values (e.g. employee GLFH-EMP → GLH15 $60 + GLH10 $40). findRestrictingEntry
      // picks the selected-variant row when present, else the blank/global row —
      // so unscoped offers keep working unchanged.
      const restrictingDiscounts = (Array.isArray(cfg.restrictingDiscounts) ? cfg.restrictingDiscounts : [])
        .map(function (e) {
          return {
            code: String((e && e.code) || '').trim().toUpperCase(),
            codePrefix: String((e && e.codePrefix) || '').trim().toUpperCase(),
            cents: Math.max(0, Number(e && e.cents) || 0),
            pct: Math.max(0, Number(e && e.pct) || 0),
            variantSku: String((e && e.variantSku) || '').trim().toUpperCase(),
            maxQty: Math.max(0, Number(e && e.maxQty) || 0),
          };
        })
        .filter(function (e) { return e.code || e.codePrefix; });
      // Backward-compat: fall back to legacy single-code config if list is empty.
      if (!restrictingDiscounts.length) {
        const legacyCode = String(cfg.restrictingDiscountCode || '').trim().toUpperCase();
        if (legacyCode) {
          restrictingDiscounts.push({ code: legacyCode, cents: Math.max(0, Number(cfg.restrictingDiscountCents) || 0), pct: 0, variantSku: '', maxQty: 0 });
        }
      }
      const restrictingCodes = restrictingDiscounts.map(function (e) { return e.code; });
      let activeRestrictingCents = 0; // cents of the restricting code currently on the cart (0 = none)
      let activeRestrictingPct = 0; // percent off (0 = use cents / none)
      let activeRestrictingCode = ''; // upper-case code currently on the cart ('' = none)
      let activeRestrictingVariantSku = ''; // upper-case SKU the price rewrite is scoped to ('' = every variant)
      let activeRestrictingMaxQty = 0; // per-order cap on the scoped variant (0 = no cap; the Function enforces server-side)
      let activeRestrictingScopeQty = 0; // current cart qty of the scoped variant (0 = none / no code active)
      const productForm = productFormId ? document.forms[productFormId] : undefined;
      const planWithAnnualCard = root.querySelector('[data-fh-plan-with-annual]');
      const restrictingHelperEl = root.querySelector('[data-fh-restricting-helper]');
      const planPickerEl = root.querySelector('[data-fh-plan-picker]');
      const planPickerLabelEl = root.querySelector('[data-fh-plan-picker-label]');
      const planWithoutTitleDefaultEl = root.querySelector('[data-fh-plan-without-title-default]');
      const planWithoutTitleRestrictingEl = root.querySelector('[data-fh-plan-without-title-restricting]');
      const planWithoutBodyDefaultEl = root.querySelector('[data-fh-plan-without-body-default]');
      const planWithoutBodyRestrictingEl = root.querySelector('[data-fh-plan-without-body-restricting]');
      const planWithoutHeaderRestrictingEl = root.querySelector('[data-fh-plan-without-header-restricting]');
      const planWithoutPillEl = root.querySelector('[data-fh-plan-without-pill]');
      // Per-code device-only card copy, sourced from the `device_only_offer`
      // metaobjects via cfg.restrictingCopy (shop metafield
      // custom.fh_device_only_offers). Editable in the Admin metaobject editor —
      // no theme deploy. Keyed by upper-case redeem code. When a restricting code
      // is applied, header/body are swapped to THAT code's entry
      // (matchedRestrictingDiscount → activeRestrictingCode). A code with no entry
      // (or empty header+body) falls back to the Liquid default $30 body with no
      // promo header — same behavior as an absent key in the former hardcoded map.
      // headerHtml / bodyHtml are theme-trusted strings (innerHTML), authored in
      // the metaobject editor.
      // An offer can have one row per SKU (15" and 10" priced differently under
      // one code), so copy is keyed by code+SKU as well as by code alone.
      //   1. exact   code|SKU   - per-size copy/badge when the row defines one
      //   2. code    code       - first row carrying copy; preserves the long-
      //                           standing behaviour where a single row's body
      //                           serves every size
      //   3. prefix             - same row choice as the price
      //                           (collectRestrictingEntries): longest
      //                           matching prefix only, so GLFH cannot
      //                           take over a GLFH-EMP code. Within it,
      //                           each field comes from the selected
      //                           size's row, else the blank-SKU row, else
      //                           any row, so a per-size badge follows the
      //                           size while a body kept on the blank-SKU
      //                           row still shows.
      // Tier 2 matters: without it, selecting a size whose row has no copy
      // would fall through to the hardcoded default body and advertise the
      // wrong amount.
      const RESTRICTING_COPY = {};
      const RESTRICTING_COPY_PREFIXES = [];
      (Array.isArray(cfg.restrictingCopy) ? cfg.restrictingCopy : []).forEach(function (e) {
        if (!e) return;
        const code = String(e.code || '').trim().toUpperCase();
        const prefix = String(e.codePrefix || '').trim().toUpperCase();
        const sku = String(e.variantSku || '').trim().toUpperCase();
        const headerHtml = e.headerHtml || '';
        const bodyHtml = e.bodyHtml || '';
        const badge = e.badge || '';
        const cardTitle = String(e.cardTitle || '').trim();
        const image = e.imageSrc
          ? { src: String(e.imageSrc), srcset: String(e.imageSrcset || ''), alt: String(e.imageAlt || '') }
          : null;
        const copy = { headerHtml: headerHtml, bodyHtml: bodyHtml, badge: badge, cardTitle: cardTitle, image: image };
        // Prefix rows are kept even without copy so they still claim the
        // prefix length; otherwise a copy-less GLFH-EMP set would fall back
        // to GLFH's copy while the price came from GLFH-EMP.
        if (prefix) RESTRICTING_COPY_PREFIXES.push({ prefix: prefix, sku: sku, copy: copy });
        if (!headerHtml && !bodyHtml && !badge && !cardTitle && !image) return;
        if (code && sku) RESTRICTING_COPY[code + '|' + sku] = copy;
        // First row wins the code-only key so the fallback is stable rather
        // than depending on the order of the shop's offer list.
        if (code && !RESTRICTING_COPY[code]) RESTRICTING_COPY[code] = copy;
      });
      function resolvePrefixCopy(code, sku) {
        let bestLen = 0;
        let rows = [];
        for (let i = 0; i < RESTRICTING_COPY_PREFIXES.length; i++) {
          const p = RESTRICTING_COPY_PREFIXES[i];
          if (code.indexOf(p.prefix) !== 0) continue;
          if (p.prefix.length > bestLen) {
            bestLen = p.prefix.length;
            rows = [p];
          } else if (p.prefix.length === bestLen) {
            rows.push(p);
          }
        }
        if (!rows.length) return null;
        const wantSku = String(sku || '').trim().toUpperCase();
        const own = rows.filter(function (r) { return wantSku && r.sku === wantSku; })
          .concat(rows.filter(function (r) { return !r.sku; }));
        const others = rows.filter(function (r) { return r.sku && r.sku !== wantSku; });
        function pick(field, list, empty) {
          for (let i = 0; i < list.length; i++) {
            if (list[i].copy[field]) return list[i].copy[field];
          }
          return empty;
        }
        // Header/body may come from another size's row, as tier 2 allows. The
        // badge, card title and image are size-specific, so another size's
        // never shows.
        const all = own.concat(others);
        const sized = wantSku ? own : all;
        const copy = {
          headerHtml: pick('headerHtml', all, ''),
          bodyHtml: pick('bodyHtml', all, ''),
          badge: pick('badge', sized, ''),
          cardTitle: pick('cardTitle', sized, ''),
          image: pick('image', sized, null),
        };
        return copy.headerHtml || copy.bodyHtml || copy.badge || copy.cardTitle || copy.image ? copy : null;
      }
      function resolveRestrictingCopy(code, sku) {
        if (!code) return null;
        const scoped = sku ? RESTRICTING_COPY[code + '|' + String(sku).toUpperCase()] : null;
        if (scoped) return scoped;
        if (RESTRICTING_COPY[code]) return RESTRICTING_COPY[code];
        return resolvePrefixCopy(code, sku);
      }
      // Offer image on the leading gallery slide and its thumbnail. The leading
      // slide is whichever size is selected (leadVariantMedia reorders it), so
      // the swap is re-rendered after every reorder and the original src/srcset
      // is put back first. Only image slides are touched; a video or 3D model
      // in front is left alone.
      let offerImage = null;
      let offerImageSwaps = [];
      function renderOfferImage() {
        offerImageSwaps.forEach(function (s) {
          s.img.srcset = s.srcset;
          s.img.src = s.src;
          s.img.alt = s.alt;
        });
        offerImageSwaps = [];
        if (!offerImage) return;
        const gallery = root.querySelector('media-gallery');
        if (!gallery) return;
        const slide = gallery.querySelector('slider-element [data-media-id]');
        if (!slide || slide.getAttribute('data-media-type') !== 'image') return;
        const thumb = gallery.querySelector(
          'media-dots [data-media-id="' + slide.getAttribute('data-media-id') + '"]'
        );
        [slide, thumb].forEach(function (el) {
          if (!el) return;
          const img = el.querySelector('img');
          if (!img) return;
          offerImageSwaps.push({
            img: img,
            src: img.getAttribute('src') || '',
            srcset: img.getAttribute('srcset') || '',
            alt: img.getAttribute('alt') || '',
          });
          img.srcset = offerImage.srcset;
          img.src = offerImage.src;
          if (offerImage.alt) img.alt = offerImage.alt;
        });
      }

      // Badge on the device-only card. Text is plain (not HTML) so a stray tag
      // in the metaobject cannot break the card layout.
      function applyRestrictingPill(copy) {
        offerImage = copy && copy.image ? copy.image : null;
        renderOfferImage();
        if (!planWithoutPillEl) return;
        const text = copy && copy.badge ? String(copy.badge).trim() : '';
        if (text) {
          planWithoutPillEl.textContent = text;
          planWithoutPillEl.removeAttribute('hidden');
        } else {
          planWithoutPillEl.textContent = '';
          planWithoutPillEl.setAttribute('hidden', '');
        }
      }

      // Wire "See terms" in restricting body copy to #member-offer-disclaimer
      // (footer legal block from snippets/member-offer-disclaimer). Authors can
      // also put <a href="#member-offer-disclaimer">…</a> in the metaobject body;
      // if already present we leave the HTML alone. Otherwise plain "See terms"
      // / "See terms." (optionally wrapped in <strong>/<b>) becomes a jump link.
      function ensureDisclaimerJumpLink(el) {
        if (!el) return;
        if (el.querySelector('a[href="#member-offer-disclaimer"]')) return;
        const html = el.innerHTML;
        if (!html || !/See terms/i.test(html)) return;
        const next = html.replace(
          /(?:<(?:strong|b)(?:\s[^>]*)?>\s*)?(See terms)(\.?)(?:\s*<\/(?:strong|b)>)?/gi,
          '<a href="#member-offer-disclaimer">$1</a>$2'
        );
        if (next !== html) el.innerHTML = next;
      }
      const defaultRestrictingBodyHtml = planWithoutBodyRestrictingEl
        ? planWithoutBodyRestrictingEl.innerHTML
        : '';
      const defaultRestrictingTitle = planWithoutTitleRestrictingEl
        ? planWithoutTitleRestrictingEl.textContent
        : '';
      let annualPlanRestricted = false;

      if (restrictingCodes.length) {
        window.FH_RESTRICTING_DISCOUNT_CODES = restrictingCodes.filter(Boolean);
        window.FH_RESTRICTING_DISCOUNT_CODE = window.FH_RESTRICTING_DISCOUNT_CODES[0] || ''; // legacy single-code global
      }
      // Prefix-only offers (e.g. GLFH-* Family Hub referral codes) have a blank
      // `code` and a non-blank `codePrefix`. Expose them for the modal / other
      // surfaces that aren't rendered with the full restrictingDiscounts list.
      window.FH_RESTRICTING_DISCOUNT_PREFIXES = restrictingDiscounts
        .map(function (e) { return e.codePrefix; })
        .filter(Boolean);

      // Returns the matched { code, cents, pct } entry for the restricting code
      // whose PDP copy/price we should show, or null if none is applied.
      //
      // A second /discount/CODE link does not clear the first. Shopify keeps every
      // clicked code in cart.discount_codes. Amount-off codes that conflict usually
      // leave one applicable:true; percentage + amount can both stay applicable.
      // Array order alone is not a reliable "most recent" signal.
      //
      // Authoritative intent: the `discount_code` cookie Shopify sets on every
      // /discount/CODE visit (path=/, not HttpOnly) — always the latest offer
      // link clicked. Prefer that when it is a known restricting code still
      // present in cart.discount_codes. Fall back to last applicable, then last
      // match (empty-cart: every code is applicable:false).
      function getDiscountCodeCookie() {
        try {
          const match = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
          return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')).trim().toUpperCase() : '';
        } catch (_) {
          return '';
        }
      }

      // Match an applied cart code to restrictingDiscounts entries by EXACT
      // code first, then by codePrefix startsWith. Prefix entries let one
      // metaobject cover a giveaway of many codes without paying the Liquid
      // list.metaobject_reference 50-item cap. Exact-match wins over prefix
      // when both would apply, so a per-code override still works.
      //
      // When several rows share the same code/prefix (variant-specific amounts),
      // collect them all and pick: selected variantSku → blank/global → (cart-
      // level only) first row. Longest matching prefix wins over a shorter one
      // (GLFH-EMP beats GLFH) so overlapping prefixes can't steal the match.
      function collectRestrictingEntries(appliedCode) {
        if (!appliedCode) return [];
        const exact = [];
        for (let j = 0; j < restrictingDiscounts.length; j++) {
          if (restrictingDiscounts[j].code && restrictingDiscounts[j].code === appliedCode) {
            exact.push(restrictingDiscounts[j]);
          }
        }
        if (exact.length) return exact;
        let bestLen = 0;
        const prefixHits = [];
        for (let j = 0; j < restrictingDiscounts.length; j++) {
          const p = restrictingDiscounts[j].codePrefix;
          if (!p || appliedCode.indexOf(p) !== 0) continue;
          if (p.length > bestLen) {
            bestLen = p.length;
            prefixHits.length = 0;
            prefixHits.push(restrictingDiscounts[j]);
          } else if (p.length === bestLen) {
            prefixHits.push(restrictingDiscounts[j]);
          }
        }
        return prefixHits;
      }

      function pickRestrictingEntry(entries, variantSku) {
        if (!entries || !entries.length) return null;
        const sku = String(variantSku || '').trim().toUpperCase();
        if (sku) {
          for (let i = 0; i < entries.length; i++) {
            if (entries[i].variantSku === sku) return entries[i];
          }
          for (let i = 0; i < entries.length; i++) {
            if (!entries[i].variantSku) return entries[i];
          }
          return null;
        }
        for (let i = 0; i < entries.length; i++) {
          if (!entries[i].variantSku) return entries[i];
        }
        return entries[0];
      }

      function findRestrictingEntry(appliedCode, variantSku) {
        return pickRestrictingEntry(collectRestrictingEntries(appliedCode), variantSku);
      }

      function applyRestrictingEntryState(entry) {
        activeRestrictingCents = entry ? entry.cents : 0;
        activeRestrictingPct = entry ? entry.pct : 0;
        activeRestrictingVariantSku = entry ? (entry.variantSku || '') : '';
        activeRestrictingMaxQty = entry ? (entry.maxQty || 0) : 0;
      }

      function matchedRestrictingDiscount(cart) {
        if (!restrictingDiscounts.length || !cart) return null;
        const applied = cart.discount_codes || [];
        const byCode = {};
        let lastApplicable = null;
        let lastAny = null;
        for (let i = 0; i < applied.length; i++) {
          const entry = applied[i];
          if (!entry || !entry.code) continue;
          const code = String(entry.code).trim().toUpperCase();
          const match = findRestrictingEntry(code);
          if (!match) continue;
          // Stamp the applied cart code onto the entry. Prefix-only metaobjects
          // have a blank `code` field; without the applied code, copy lookup,
          // shouldRestrictThisVariant, and scoped ATC all no-op and syncVariant
          // can clear the annual-plan restriction on the next paint.
          const stamped = Object.assign({}, match, { code: code });
          byCode[code] = stamped;
          lastAny = stamped;
          if (entry.applicable !== false) lastApplicable = stamped;
        }
        const cookieCode = getDiscountCodeCookie();
        if (cookieCode && byCode[cookieCode]) return byCode[cookieCode];
        return lastApplicable || lastAny;
      }

      function cartHasRestrictingDiscountCode(cart) {
        return !!matchedRestrictingDiscount(cart);
      }

      /**
       * Header + body + badge for the restricting card, resolved for the code
       * that is applied AND the size that is selected.
       *
       * Extracted so the size-change path can call it too. syncVariant() used
       * to refresh only the badge when the restricted state was unchanged
       * between sizes, which left the body showing whichever size rendered
       * first: an employee code on 10" kept the 15" row's "$60 off ... $180
       * value" even though the GLH10 row says $40 / $160. The badge followed
       * the size; the body did not.
       *
       * Safe to call from syncVariant() - unlike applyAnnualPlanRestriction,
       * this touches no state that calls back into syncVariant.
       */
      function renderRestrictingCopy() {
        // Re-resolved every call so both switching offer links ($30 -> $50 ->
        // 15%) and switching size land on the right row.
        const copy = activeRestrictingCode
          ? resolveRestrictingCopy(activeRestrictingCode, selectedVariantSku)
          : null;
        // Card title is per size like the badge: a size whose row has no
        // card_title gets the default, not the other size's title.
        if (planWithoutTitleRestrictingEl) {
          planWithoutTitleRestrictingEl.textContent =
            (copy && copy.cardTitle) || defaultRestrictingTitle;
        }
        if (!planWithoutBodyRestrictingEl) return;
        planWithoutBodyRestrictingEl.innerHTML = copy ? copy.bodyHtml : defaultRestrictingBodyHtml;
        ensureDisclaimerJumpLink(planWithoutBodyRestrictingEl);
        planWithoutBodyRestrictingEl.removeAttribute('hidden');
        if (planWithoutHeaderRestrictingEl) {
          if (copy && copy.headerHtml) {
            planWithoutHeaderRestrictingEl.innerHTML = copy.headerHtml;
            planWithoutHeaderRestrictingEl.removeAttribute('hidden');
          } else {
            planWithoutHeaderRestrictingEl.innerHTML = '';
            planWithoutHeaderRestrictingEl.setAttribute('hidden', '');
          }
        }
        applyRestrictingPill(copy);
      }

      function applyAnnualPlanRestriction(restricted) {
        annualPlanRestricted = restricted;
        if (planPickerEl) {
          planPickerEl.classList.toggle('fh-plan-picker--restricted', restricted);
        }
        if (planPickerLabelEl) {
          if (restricted) planPickerLabelEl.setAttribute('hidden', '');
          else planPickerLabelEl.removeAttribute('hidden');
        }
        if (planWithoutTitleDefaultEl) {
          if (restricted) planWithoutTitleDefaultEl.setAttribute('hidden', '');
          else planWithoutTitleDefaultEl.removeAttribute('hidden');
        }
        if (planWithoutTitleRestrictingEl) {
          // Text is set by renderRestrictingCopy() so it also follows size changes.
          if (restricted) planWithoutTitleRestrictingEl.removeAttribute('hidden');
          else planWithoutTitleRestrictingEl.setAttribute('hidden', '');
        }
        if (planWithoutBodyDefaultEl) {
          if (restricted) planWithoutBodyDefaultEl.setAttribute('hidden', '');
          else planWithoutBodyDefaultEl.removeAttribute('hidden');
        }
        if (planWithoutBodyRestrictingEl) {
          if (restricted) {
            renderRestrictingCopy();
          } else {
            planWithoutBodyRestrictingEl.setAttribute('hidden', '');
            planWithoutBodyRestrictingEl.innerHTML = defaultRestrictingBodyHtml;
            if (planWithoutHeaderRestrictingEl) {
              planWithoutHeaderRestrictingEl.innerHTML = '';
              planWithoutHeaderRestrictingEl.setAttribute('hidden', '');
            }
            applyRestrictingPill(null);
          }
        }
        if (planWithAnnualCard) {
          planWithAnnualCard.classList.toggle('fh-plan-card--annual-restricted', restricted);
          if (restricted) {
            planWithAnnualCard.setAttribute('aria-hidden', 'true');
            planWithAnnualCard.classList.remove('is-selected');
            planWithAnnualCard.setAttribute('aria-checked', 'false');
            planWithAnnualCard.tabIndex = -1;
          } else {
            planWithAnnualCard.removeAttribute('aria-hidden');
          }
        }
        if (restrictingHelperEl) {
          restrictingHelperEl.setAttribute('hidden', '');
        }
        // Always select the device-only card when restricted so per-code copy
        // is visible (compact body is gated on is-selected in non-restricted CSS).
        if (restricted) {
          selectedPlan = PLAN_BUNDLE_DEVICE_ONLY;
          planCards.forEach((item) => {
            const active = item.dataset.planValue === selectedPlan;
            const hidden = item.classList.contains('fh-plan-card--annual-restricted');
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-checked', String(active));
            if (!hidden) item.tabIndex = active ? 0 : -1;
          });
          syncVariant({ dispatchGalleryEvent: false });
          placeAtcButton();
        } else {
          syncVariant({ dispatchGalleryEvent: false });
        }
      }

      function refreshRestrictingDiscountUi(cart) {
        const matched = matchedRestrictingDiscount(cart);
        activeRestrictingCode = matched ? matched.code : '';
        // Cart-level pick has no selected variant yet — prefer global / first.
        // syncVariant re-applies with the selected SKU so multi-variant prefix
        // rows (employee $60/$40) land on the right amount when size changes.
        applyRestrictingEntryState(matched);
        // How many units of the scoped SKU (e.g. GLH15 for a giveaway) the cart
        // holds right now. syncVariant reads this to disable ATC / relabel it
        // "Already in your cart" when the shopper is on the scoped variant and
        // the cap is already reached. Unscoped codes leave it at 0 — the pre-
        // scope ATC behavior is untouched.
        activeRestrictingScopeQty = 0;
        if (matched && activeRestrictingVariantSku && cart && Array.isArray(cart.items)) {
          for (var i = 0; i < cart.items.length; i++) {
            var it = cart.items[i];
            if (!it || !it.sku) continue;
            if (String(it.sku).toUpperCase() === activeRestrictingVariantSku) {
              activeRestrictingScopeQty += Number(it.quantity) || 0;
            }
          }
        }
        applyAnnualPlanRestriction(!!matched);
      }

      function restrictedDevicePriceCents(variantPriceCents) {
        if (activeRestrictingPct > 0) {
          return Math.max(0, Math.round(variantPriceCents * (1 - activeRestrictingPct / 100)));
        }
        if (activeRestrictingCents > 0) {
          return Math.max(0, variantPriceCents - activeRestrictingCents);
        }
        return variantPriceCents;
      }

      function hasActiveRestrictingPrice() {
        return activeRestrictingPct > 0 || activeRestrictingCents > 0;
      }

      // True when the active restricting code's PDP price rewrite covers this
      // variant. An empty scope (every existing offer) covers every variant, so
      // the pre-scope behavior is preserved for those codes. A variant-scoped
      // code (e.g. a 15"-only giveaway) leaves the other size at its regular
      // price on the PDP — matching what Shopify will actually charge, since
      // the discount is created with productVariantsToAdd for that one variant.
      // When the same prefix has one row per SKU (employee), each size resolves
      // to its own row and both stay covered.
      function restrictingAppliesToVariant(variantSku) {
        if (!activeRestrictingCode) return false;
        return !!findRestrictingEntry(activeRestrictingCode, variantSku);
      }

      function familyHubDevicesInCart(cart) {
        if (typeof window.fhFamilyHubDeviceCount === 'function') {
          return window.fhFamilyHubDeviceCount(cart);
        }
        var items = (cart && cart.items) || [];
        var n = 0;
        for (var i = 0; i < items.length; i++) {
          var it = items[i];
          if (!it || !it.requires_shipping || !it.sku) continue;
          if (it.sku === 'GLH10' || it.sku === 'GLH15') n += it.quantity || 0;
        }
        return n;
      }

      function fhCartJsonUrl() {
        try {
          if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
            return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
          }
        } catch (_) {}
        return '/cart.js';
      }

      // Locale-safe cart PAGE url (not /cart.js) — used to redirect after ATC.
      function fhCartPageUrl() {
        try {
          if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
            return window.theme.routes.cart_url;
          }
        } catch (_) {}
        return '/cart';
      }

      // Locale-safe checkout url — used to redirect after Express Checkout ATC.
      function fhCheckoutUrl() {
        return fhCartPageUrl().replace(/\/?$/, '') + '/checkout';
      }
      // No setTimeout debounce: rapid cart:updated / pubsub bursts (drawer remove,
      // orphan sub flush) kept resetting the timer so the PDP never updated until
      // the tab went to background (timer coalescing). fh-cart-sync also syncs
      // `[data-plan-atc]` synchronously from event cart JSON; this fetch is backup.
      function refreshFhDeviceCapUi() {
        var capUrl = fhCartJsonUrl();
        capUrl += (capUrl.indexOf('?') >= 0 ? '&' : '?') + 'fh_cap=' + Date.now();
        fetch(capUrl, { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) {
            return r.json();
          })
          .then(function (cart) {
            refreshRestrictingDiscountUi(cart);
            var n = familyHubDevicesInCart(cart);
            if (!atcBtn) return;
            var atCap = n >= MAX_FH_DEVICES;
            if (atCap) {
              atcBtn.disabled = true;
              atcBtn.setAttribute('data-fh-device-cap-reached', 'true');
            } else {
              atcBtn.removeAttribute('data-fh-device-cap-reached');
              try {
                atcBtn.removeAttribute('aria-disabled');
              } catch (_) {}
              atcBtn.disabled = false;
              syncVariant({ dispatchGalleryEvent: false });
            }
          })
          .catch(function () {});
      }

      function bindFhDeviceCapCartListeners() {
        if (!window.__fhFamilyHubCapRefreshers) {
          window.__fhFamilyHubCapRefreshers = [];
        }
        window.__fhFamilyHubCapRefreshers.push(refreshFhDeviceCapUi);
        if (!window.__fhFamilyHubCartCapListenersBound) {
          window.__fhFamilyHubCartCapListenersBound = true;
          var runAllCapRefreshers = function () {
            (window.__fhFamilyHubCapRefreshers || []).forEach(function (fn) {
              try {
                fn();
              } catch (eFn) {}
            });
          };
          document.addEventListener('cart:updated', runAllCapRefreshers);
          // Drawer empty-state re-renders after fh-cart-sync orphan flush use
          // cart:refresh; cart:updated can miss the final empty cart in some races.
          document.addEventListener('cart:refresh', runAllCapRefreshers);
          try {
            if (
              window.theme &&
              window.theme.pubsub &&
              window.theme.pubsub.PUB_SUB_EVENTS &&
              typeof window.theme.pubsub.subscribe === 'function'
            ) {
              window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, runAllCapRefreshers);
            }
          } catch (_) {}
        }
      }

      /** Bundle choice only (not tied to size option index). Matches data-plan-value on plan cards. */
      const PLAN_BUNDLE_WITH_SUBSCRIPTION = 'With Annual Plan';
      const PLAN_BUNDLE_DEVICE_ONLY = 'Without Annual Plan';
      let selectedPlan = PLAN_BUNDLE_WITH_SUBSCRIPTION;

    const money = (cents) => `$${(cents / 100).toFixed(2)}`;
    const isWithPlan = (planValue) => planValue === PLAN_BUNDLE_WITH_SUBSCRIPTION;
    const placeAtcButton = () => {
      if (!atcBtn) return;
      const anchorSel = isWithPlan(selectedPlan)
        ? '[data-atc-anchor="featured"]'
        : '[data-atc-anchor="compact"]';
      const anchor = root.querySelector(anchorSel);
      if (anchor) {
        // Express Checkout appended first so it always sits above "Add to
        // cart" — appendChild re-parents (or reorders, if already a child),
        // so this also re-asserts the order on every call, not just when the
        // plan just changed.
        if (expressBtn) anchor.appendChild(expressBtn);
        anchor.appendChild(atcBtn);
      }
      root.querySelectorAll('[data-atc-anchor].fh-plan-atc-anchor--slot').forEach((el) => {
        el.classList.toggle('fh-plan-atc-anchor--inactive', !el.contains(atcBtn));
      });
    };
    const optionKeyForSize = () =>
      sizeOptIndex === null ? null : `option${Number(sizeOptIndex) + 1}`;

    const getVariant = (size) => {
      if (sizeOptIndex === null) return variants[0];
      const optionKey = optionKeyForSize();
      return variants.find((variant) => variant[optionKey] === size);
    };

    const getVariantById = (id) => variants.find((v) => Number(v.id) === Number(id));

    /**
     * Moves the selected variant's image to the front of the carousel and the thumbnail
     * rail, so the leading slide always shows the size that's currently selected.
     *
     * Mirrors the prepend branch of the theme's MediaGallery.setActiveMedia(), but stays
     * local on purpose. Dispatching `variant:change` instead would hand this product's
     * media and options to the theme's own variant components — this section renders its
     * own price, badge and option UI — and would scroll the page up to the gallery on
     * every size tap at <=767px. Because the theme hides
     * `.product__media--variant:not(:first-child)`, reordering alone is enough to reveal
     * the newly selected size's image and hide the previous one.
     */
    const leadVariantMedia = (variant) => {
      const mediaId = variant?.featured_media?.id;
      if (!mediaId) return;
      const gallery = root.querySelector('media-gallery');
      if (!gallery) return;

      const slider = gallery.querySelector('slider-element');
      const slide = slider?.querySelector(`[data-media-id="${mediaId}"]`);
      if (slide) {
        slide.parentElement.prepend(slide);
        slider.reset();
        slider.select(1, true);
      }

      const dots = gallery.querySelector('media-dots');
      const thumb = dots?.querySelector(`[data-media-id="${mediaId}"]`);
      if (thumb) {
        thumb.parentElement.prepend(thumb);
        dots.reset();
        dots.resetIndexes();
      }
      // The slide now in front is a different size's; move the offer image to it.
      renderOfferImage();
      fhLog('leadVariantMedia()', { mediaId, slideFound: !!slide, thumbFound: !!thumb });
    };

    /**
     * @param {{ dispatchGalleryEvent?: boolean }} [opts]
     *   dispatchGalleryEvent — when false, skip `variant:change` on the product form. This
     *   section keeps it false everywhere and drives the gallery itself via
     *   leadVariantMedia(), so the theme's variant components don't fight this section's
     *   own price/option rendering.
     */
    const syncVariant = (opts) => {
      opts = opts || {};
      const dispatchGalleryEvent = opts.dispatchGalleryEvent !== false;
      const byId = getVariantById(selectedVariantId);
      const bySize = getVariant(selectedSize);
      const fallback = variants[0];
      const variant = byId || bySize || fallback;
      let resolvedVia = 'none';
      if (variant) {
        if (byId && variant.id === byId.id) resolvedVia = 'selectedVariantId';
        else if (bySize && variant.id === bySize.id) resolvedVia = 'selectedSize string match';
        else if (fallback && variant.id === fallback.id) resolvedVia = 'variants[0] fallback';
      }
      fhLog('syncVariant()', {
        resolvedVia,
        selectedVariantId,
        selectedSize,
        selectedPlan,
        variantFound: !!variant,
        variantId: variant?.id,
        optionKey: optionKeyForSize(),
        variantOptions: variant
          ? {
              option1: variant.option1,
              option2: variant.option2,
              option3: variant.option3,
            }
          : null,
        productFormFound: !!productForm,
      });
      if (!variant) {
        fhLog('syncVariant() aborted — no variant');
        return;
      }
      selectedVariantId = variant.id;
      selectedVariantSku = String(variant.sku || '').toUpperCase();
      const ok = optionKeyForSize();
      if (ok) selectedSize = variant[ok];
      // Variant-scoped restricting code (e.g. a 15"-only giveaway): the cart-
      // refresh path hides the annual bundle for every variant of this product,
      // which is right for legacy unscoped codes but wrong for a code that only
      // applies to one SKU. Refine annual visibility per selected variant here
      // so switching 15" ↔ 10" restores the annual path for the out-of-scope
      // size. Also re-pick cents/pct when the same prefix has one row per SKU.
      // No-op when no code is active, or when scope is unset (legacy).
      if (activeRestrictingCode) {
        applyRestrictingEntryState(findRestrictingEntry(activeRestrictingCode, variant.sku));
      }
      const shouldRestrictThisVariant = !!activeRestrictingCode && restrictingAppliesToVariant(variant.sku);
      if (shouldRestrictThisVariant !== annualPlanRestricted) {
        applyAnnualPlanRestriction(shouldRestrictThisVariant);
      } else if (annualPlanRestricted && activeRestrictingCode) {
        // Same restricted state, different size: re-resolve so the per-SKU
        // badge AND the header/body follow the selection. Refreshing only the
        // badge here left the body on whichever size rendered first.
        // applyAnnualPlanRestriction is not re-entered because it calls
        // syncVariant; renderRestrictingCopy does not.
        renderRestrictingCopy();
      }
      // trueVariantPriceCents is the real catalog price (this fetch never
      // reflects automatic discounts); flashCents layers the Flash Sale
      // metaobject on top of it, same as the Liquid-side initial render.
      const trueVariantPriceCents = Number(variant.price) || 0;
      const flashCents = flashSaleDiscountedCents(trueVariantPriceCents, Number(variant.compare_at_price) || 0, variant.sku);
      const flashActiveForVariant = flashCents < trueVariantPriceCents;
      // The $20 bundle discount and the flash sale are both non-combining
      // product discounts at checkout, so they never both apply — Shopify
      // keeps whichever is more valuable to the customer. min() mirrors that
      // instead of summing both (same pattern as the restricting-code compare
      // just below).
      const variantDiscountCents = discountCentsFor(variant.sku);
      const bundleCents = Math.max(0, trueVariantPriceCents - variantDiscountCents);
      const withPlanCents = Math.min(flashCents, bundleCents);
      const flashFormatted = money(flashCents);
      const trueFormatted = money(trueVariantPriceCents);
      const withPlanFormatted = money(withPlanCents);
      if (planWithPriceEl) planWithPriceEl.textContent = withPlanFormatted;
      // Checkout doesn't let a restricting code "replace" the flash sale
      // outright — when two non-combining discounts could both apply,
      // Shopify keeps whichever is more valuable to the customer (confirmed
      // empirically for the sf_member mechanism; same combinesWith logic
      // applies here). So compare both candidates instead of assuming the
      // code always wins.
      const restrictingCoversVariant = annualPlanRestricted && hasActiveRestrictingPrice() && restrictingAppliesToVariant(variant.sku);
      let withoutPlanCents = flashCents;
      let restrictingWins = false;
      if (restrictingCoversVariant) {
        const restrictingCents = restrictedDevicePriceCents(trueVariantPriceCents);
        if (restrictingCents <= flashCents) {
          withoutPlanCents = restrictingCents;
          restrictingWins = true;
        }
      }
      if (planWithoutPriceEl) {
        planWithoutPriceEl.textContent = money(withoutPlanCents);
      }
      if (planWithoutCompareEl) {
        if (restrictingWins || flashActiveForVariant) {
          planWithoutCompareEl.textContent = trueFormatted;
          planWithoutCompareEl.removeAttribute('hidden');
        } else {
          planWithoutCompareEl.textContent = '';
          planWithoutCompareEl.setAttribute('hidden', '');
        }
      }
      if (flashBadgeEl) {
        if (!restrictingWins && flashActiveForVariant) flashBadgeEl.removeAttribute('hidden');
        else flashBadgeEl.setAttribute('hidden', '');
      }
      if (planWithCompareEl) {
        if (variantDiscountCents > 0) {
          planWithCompareEl.textContent = flashFormatted;
          planWithCompareEl.removeAttribute('hidden');
        } else {
          planWithCompareEl.textContent = '';
          planWithCompareEl.setAttribute('hidden', '');
        }
      }
      if (planWithTaglineEl) {
        const tpl = planWithTaglineEl.dataset.fhTaglineTemplate || '';
        if (tpl.indexOf('{price}') >= 0) {
          planWithTaglineEl.textContent = tpl.replace(/\{price\}/g, withPlanFormatted);
        }
      }
      // Badge follows the selected size: read data-fh-plan-pill off the active size
      // card (matched by variant id, falling back to size value — same rule as the
      // is-selected toggle). Hide the badge when the selected size defines none.
      if (planWithPillEl) {
        let activeSizeCard = null;
        sizeCards.forEach((item) => {
          const itemVid = Number(item.dataset.variantId || 0);
          const isActive = itemVid ? itemVid === Number(selectedVariantId) : item.dataset.sizeValue === selectedSize;
          if (isActive) activeSizeCard = item;
        });
        const pillText = activeSizeCard ? (activeSizeCard.getAttribute('data-fh-plan-pill') || '').trim() : '';
        if (pillText) {
          planWithPillEl.textContent = pillText;
          planWithPillEl.removeAttribute('hidden');
        } else {
          planWithPillEl.setAttribute('hidden', '');
        }
      }
      if (atcBtn) {
        atcBtn.dataset.variantId = variant.id;
        atcBtn.dataset.planValue = selectedPlan;
        var invBlocked = !variant.available && variant.inventory_policy !== 'continue';
        if (invBlocked) atcBtn.setAttribute('data-fh-inventory-blocked', 'true');
        else atcBtn.removeAttribute('data-fh-inventory-blocked');
        // Variant-scoped restricting-code cap: when the giveaway code is
        // applied AND the shopper is on the scoped variant AND that variant
        // already holds max_qty units in the cart, an ATC click would just
        // trip the Function's cap error ("Try again"). Relabel to make the
        // state explicit — the free device is already secured — and disable
        // to prevent the useless click. Untouched on any other variant, any
        // other code, or no code (falls back to the label we captured at
        // birth). The cart-page guardrail handles the qty stepper.
        var scopedAtCap = activeRestrictingCode
          && activeRestrictingVariantSku
          && activeRestrictingMaxQty > 0
          && String(variant.sku || '').trim().toUpperCase() === activeRestrictingVariantSku
          && activeRestrictingScopeQty >= activeRestrictingMaxQty;
        if (!atcBtn.dataset.fhLabelDefault) atcBtn.dataset.fhLabelDefault = (atcBtn.textContent || '').trim();
        if (scopedAtCap) {
          atcBtn.setAttribute('data-fh-restricting-at-cap', 'true');
          atcBtn.textContent = 'Already in your cart';
        } else if (atcBtn.hasAttribute('data-fh-restricting-at-cap')) {
          atcBtn.removeAttribute('data-fh-restricting-at-cap');
          atcBtn.textContent = atcBtn.dataset.fhLabelDefault || 'Add to cart';
        }
        atcBtn.disabled = invBlocked || atcBtn.getAttribute('data-fh-device-cap-reached') === 'true' || scopedAtCap;
      }
      if (productForm) {
        const idInput = productForm.querySelector('input[name="id"]');
        if (idInput) idInput.value = String(variant.id);
        if (dispatchGalleryEvent) {
          productForm.dispatchEvent(
            new CustomEvent('variant:change', {
              bubbles: true,
              detail: { variant },
            })
          );
        }
      }
    };

    fhLog('init', {
      sectionId,
      sizeCards: sizeCards.length,
      planCards: planCards.length,
      sizeOptIndex,
      initialSelectedSize: selectedSize,
      initialSelectedVariantId: selectedVariantId,
      sizeCardSnapshots: Array.from(sizeCards).map((el, i) => ({
        index: i,
        variantId: el.dataset.variantId || null,
        sizeValueAttr: el.getAttribute('data-size-value'),
        datasetSizeValue: el.dataset.sizeValue,
      })),
      variantSnapshots: variants.map((v) => ({
        id: v.id,
        option1: v.option1,
        option2: v.option2,
        option3: v.option3,
        available: v.available,
      })),
    });

    sizeCards.forEach((card) => {
      card.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const t = e.target;
        fhLog('size click', {
          target: { tag: t.tagName, className: t.className },
          cardDataset: { variantId: card.dataset.variantId, sizeValue: card.dataset.sizeValue },
          rawAttr: card.getAttribute('data-size-value'),
        });
        const vid = Number(card.dataset.variantId || 0);
        const byId = vid ? getVariantById(vid) : null;
        if (byId) {
          selectedVariantId = byId.id;
          const ok = optionKeyForSize();
          if (ok) selectedSize = byId[ok];
          fhLog('size → resolved by variant id', { vid, selectedVariantId, selectedSize, byIdOption: ok ? byId[ok] : null });
        } else {
          selectedSize = card.dataset.sizeValue || selectedSize;
          const v = getVariant(selectedSize);
          if (v) selectedVariantId = v.id;
          fhLog('size → fallback string path', {
            selectedSize,
            getVariantHit: !!v,
            selectedVariantId,
          });
        }
        sizeCards.forEach((item) => {
          const itemVid = Number(item.dataset.variantId || 0);
          const active = itemVid ? itemVid === Number(selectedVariantId) : item.dataset.sizeValue === selectedSize;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-checked', String(active));
        });
        fhLog('size UI after toggle', {
          selectedVariantId,
          selectedSize,
          selectedClasses: Array.from(sizeCards).map((el) => ({
            vid: el.dataset.variantId,
            isSelected: el.classList.contains('is-selected'),
          })),
        });
        syncVariant({ dispatchGalleryEvent: false });
        leadVariantMedia(getVariantById(selectedVariantId));
      });
    });

    planCards.forEach((card, planIndex) => {
      card.addEventListener('click', (e) => {
        if (e.target.closest('.fh-atc')) {
          fhLog('plan click ignored (ATC)', { planIndex, target: e.target.tagName });
          return;
        }
        if (
          annualPlanRestricted &&
          card.dataset.planValue === PLAN_BUNDLE_WITH_SUBSCRIPTION
        ) {
          return;
        }
        e.stopPropagation();
        const prevPlan = selectedPlan;
        selectedPlan = card.dataset.planValue || selectedPlan;
        fhLog('plan click', {
          planIndex,
          target: { tag: e.target.tagName, className: e.target.className },
          cardDatasetPlan: card.dataset.planValue,
          prevPlan,
          nextPlan: selectedPlan,
          selectedVariantId,
          selectedSize,
        });
        planCards.forEach((item) => {
          const active = item.dataset.planValue === selectedPlan;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-checked', String(active));
        });
        syncVariant({ dispatchGalleryEvent: false });
        placeAtcButton();
      });
    });

    /** Compare SellingPlan ids from cart.js vs Liquid-injected GID or numeric id. */
    function normalizeSellingPlanId(id) {
      if (id == null || id === '') return '';
      return String(id).replace(/^gid:\/\/shopify\/SellingPlan\//i, '');
    }

    /** True if this cart line is the annual plan variant + same selling plan as PDP. */
    function cartLineMatchesPlanSub(line, subVid, planId) {
      if (Number(line.variant_id) !== Number(subVid)) return false;
      if (!planId) return !line.selling_plan_allocation;
      const sp = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
      if (!sp || sp.id == null) return false;
      return normalizeSellingPlanId(sp.id) === normalizeSellingPlanId(planId);
    }

    if (atcBtn) {
      atcBtn.addEventListener('click', () => {
        const variantId = Number(atcBtn.dataset.variantId || 0);
        fhLog('ATC click', {
          variantId,
          atcDatasetPlan: atcBtn.dataset.planValue,
          selectedPlan,
          selectedVariantId,
          selectedSize,
          subVariantId,
          subSellingPlanId,
        });
        if (!variantId || atcBtn.disabled) return;

        // Disable immediately (before async cap check) so double-clicks cannot
        // merge a second /cart/add.js into qty 2 before the first finishes.
        const originalLabel = atcBtn.textContent;
        atcBtn.disabled = true;
        atcBtn.textContent = 'Adding...';

        // ── Express Checkout fast path ──────────────────────────────────
        // 1 cart read (device limit + sub check) → 1 cart add → redirect.
        // Skips post-add reads, drawer, and all UI refreshes.
        // Toggle: Shopify Admin → Theme Editor → Family Hub Product → "Enable express checkout fast path"
        if (cfg.expressCheckoutFastPath && atcBtn.dataset.fhRedirectTarget === 'checkout') {
          delete atcBtn.dataset.fhRedirectTarget;
          const withPlan = isWithPlan(atcBtn.dataset.planValue);
          const bundleSku = withPlan ? bundleSkuBySize[selectedSize] : null;
          const bundleProperties = bundleSku ? { _bundle_parent_sku: bundleSku } : null;
          const deviceLine = { id: variantId, quantity: 1 };
          if (bundleProperties) deviceLine.properties = bundleProperties;

          fetch(fhCartJsonUrl())
            .then((r) => r.json())
            .then((cart) => {
              if (familyHubDevicesInCart(cart) >= MAX_FH_DEVICES) {
                atcBtn.textContent = originalLabel;
                atcBtn.disabled = true;
                atcBtn.setAttribute('data-fh-device-cap-reached', 'true');
                return;
              }

              // Build items: device always, sub only if plan selected AND not already in cart
              const expressItems = [deviceLine];
              if (withPlan && subVariantId) {
                const existingSub = (cart.items || []).find((line) =>
                  cartLineMatchesPlanSub(line, subVariantId, subSellingPlanId)
                );
                if (!existingSub) {
                  const subLine = { id: subVariantId, quantity: 1 };
                  if (subSellingPlanId) subLine.selling_plan = subSellingPlanId;
                  if (bundleProperties) subLine.properties = bundleProperties;
                  expressItems.push(subLine);
                }
              }

              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: expressItems }),
              });
            })
            .then((response) => {
              if (!response) return; // device cap hit — button already handled above
              if (!response.ok) return Promise.reject(response);
              window.location.href = fhCheckoutUrl();
            })
            .catch(() => {
              atcBtn.textContent = 'Try again';
              atcBtn.disabled = false;
              setTimeout(() => {
                atcBtn.textContent = originalLabel;
                syncVariant({ dispatchGalleryEvent: false });
              }, 1200);
            });
          return;
        }
        // ── End express checkout fast path ──────────────────────────────

        // ── Regular ATC fast path ────────────────────────────────────────
        // 1 cart read (device limit + sub check) → 1 cart add → redirect.
        // Skips post-add reads, drawer, badge, fh-cart-sync, cap UI refresh
        // — all irrelevant since user navigates to /cart which renders fresh.
        // Toggle: Shopify Admin → Theme Editor → Family Hub Product → "Enable add-to-cart fast path"
        if (cfg.atcFastPath) {
          const withPlan = isWithPlan(atcBtn.dataset.planValue);
          const bundleSku = withPlan ? bundleSkuBySize[selectedSize] : null;
          const bundleProperties = bundleSku ? { _bundle_parent_sku: bundleSku } : null;
          const deviceLine = { id: variantId, quantity: 1 };
          if (bundleProperties) deviceLine.properties = bundleProperties;

          fetch(fhCartJsonUrl())
            .then((r) => r.json())
            .then((cart) => {
              if (familyHubDevicesInCart(cart) >= MAX_FH_DEVICES) {
                atcBtn.textContent = originalLabel;
                atcBtn.disabled = true;
                atcBtn.setAttribute('data-fh-device-cap-reached', 'true');
                return;
              }

              const items = [deviceLine];
              if (withPlan && subVariantId) {
                const existingSub = (cart.items || []).find((line) =>
                  cartLineMatchesPlanSub(line, subVariantId, subSellingPlanId)
                );
                if (!existingSub) {
                  const subLine = { id: subVariantId, quantity: 1 };
                  if (subSellingPlanId) subLine.selling_plan = subSellingPlanId;
                  if (bundleProperties) subLine.properties = bundleProperties;
                  items.push(subLine);
                }
              }

              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items }),
              });
            })
            .then((response) => {
              if (!response) return;
              if (!response.ok) return Promise.reject(response);
              window.location.href = fhCartPageUrl();
            })
            .catch(() => {
              atcBtn.textContent = 'Try again';
              atcBtn.disabled = false;
              setTimeout(() => {
                atcBtn.textContent = originalLabel;
                syncVariant({ dispatchGalleryEvent: false });
              }, 1200);
            });
          return;
        }
        // ── End regular ATC fast path ────────────────────────────────────

        const runAtc = () => {
        const withPlan = isWithPlan(atcBtn.dataset.planValue);
        const bundleSku = withPlan ? bundleSkuBySize[selectedSize] : null;

        // When adding the bundle, both the device line AND the subscription
        // line are stamped with the same `_bundle_parent_sku` line item
        // property. That property is the grouping key consumed downstream by:
        //   • cart-drawer.liquid / main-cart.liquid (visual merge)
        //   • snippets/fh-cart-sync.liquid (stepper/orphan sync)
        //   • extensions/subscription-zero-price (per-bundle Annual Plan
        //     discount via attribute(key:"_bundle_parent_sku") in its query)
        // If the size doesn't have a mapping (new size, or device-only ATC),
        // we add the lines without the property and the cart shows them as
        // standalone — the discount Function and visual merge both fail
        // open in that case.
        const bundleProperties = bundleSku
          ? { _bundle_parent_sku: bundleSku }
          : null;

        const deviceLine = { id: variantId, quantity: 1 };
        if (bundleProperties) deviceLine.properties = bundleProperties;
        const items = [deviceLine];

        if (withPlan && subVariantId) {
          const subLine = { id: subVariantId, quantity: 1 };
          if (subSellingPlanId) subLine.selling_plan = subSellingPlanId;
          if (bundleProperties) subLine.properties = bundleProperties;
          items.push(subLine);
        }

        fhLog('ATC /cart/add.js payload', { items });

        const finishSuccess = (cart) => {
          // Keep disabled through redirect to avoid a second click mid-navigate.
          syncVariant({ dispatchGalleryEvent: false });
          refreshFhDeviceCapUi();
          document.querySelectorAll('cart-count').forEach((countNode) => {
            const display =
              typeof window.fhResolveDisplayItemCount === 'function'
                ? window.fhResolveDisplayItemCount(cart)
                : typeof window.fhCartDisplayItemCount === 'function'
                  ? window.fhCartDisplayItemCount(cart)
                  : cart.item_count;
            countNode.textContent = String(display);
            countNode.toggleAttribute('hidden', display === 0);
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
          const goToCheckout = atcBtn.dataset.fhRedirectTarget === 'checkout';
          delete atcBtn.dataset.fhRedirectTarget;
          window.location.href = goToCheckout ? fhCheckoutUrl() : fhCartPageUrl();
        };

        const finishError = () => {
          delete atcBtn.dataset.fhRedirectTarget;
          atcBtn.textContent = 'Try again';
          atcBtn.disabled = false;
          setTimeout(() => {
            atcBtn.textContent = originalLabel;
            syncVariant({ dispatchGalleryEvent: false });
          }, 1200);
        };

        /** Single /cart/add.js then fresh cart (first plan bundle, or device-only). */
        const addItemsThenCart = (payloadItems) =>
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: payloadItems }),
          })
            .then((response) => (response.ok ? response.json() : Promise.reject(response)))
            .then(() => fetch(fhCartJsonUrl()))
            .then((response) => response.json());

        // Device-only / plan without sub variant: one add.
        if (!withPlan || !subVariantId) {
          addItemsThenCart(items).then(finishSuccess).catch(finishError);
          return;
        }

        // With plan: reuse single subscription line when already in cart.
        fetch(fhCartJsonUrl())
          .then((response) => response.json())
          .then((cart) => {
            const existingSub = (cart.items || []).find((line) =>
              cartLineMatchesPlanSub(line, subVariantId, subSellingPlanId)
            );

            if (!existingSub) {
              fhLog('ATC first plan bundle — device + sub');
              return addItemsThenCart(items);
            }

            fhLog('ATC extra plan bundle — device only (subscription stays qty 1)', {
              subKey: existingSub.key,
            });

            const deviceOnly = [deviceLine];
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: deviceOnly }),
            })
              .then((response) => {
                if (!response.ok) return Promise.reject(response);
                return response.json();
              })
              .then(() => fetch(fhCartJsonUrl()).then((r) => r.json()));
          })
          .then(finishSuccess)
          .catch(finishError);
        };

        fetch(fhCartJsonUrl())
          .then((r) => r.json())
          .then((cart) => {
            if (familyHubDevicesInCart(cart) >= MAX_FH_DEVICES) {
              fhLog('ATC blocked — at Family Hub device limit');
              delete atcBtn.dataset.fhRedirectTarget;
              atcBtn.textContent = originalLabel;
              atcBtn.disabled = true;
              atcBtn.setAttribute('data-fh-device-cap-reached', 'true');
              return;
            }
            runAtc();
          })
          .catch(() => {
            runAtc();
          });
      });
    }

    // Mobile floating add-to-cart (Nike-style): proxies the real ATC button,
    // mirrors its label + disabled state, and hides whenever the real button is
    // visible in the viewport.
    const floatingAtc = root.querySelector('[data-fh-floating-atc]');
    if (floatingAtc && atcBtn) {
      const floatingLabel =
        floatingAtc.querySelector('[data-fh-floating-atc-label]') || floatingAtc;
      const syncFloatingAtc = () => {
        const label = (atcBtn.textContent || '').trim();
        if (label) floatingLabel.textContent = label;
        floatingAtc.disabled = atcBtn.disabled;
      };

      floatingAtc.addEventListener('click', () => {
        if (atcBtn.disabled) return;
        atcBtn.click();
      });

      // Mirror the real button's label ("Adding...", "Try again") and disabled
      // state (inventory-blocked / device-cap) without duplicating that logic.
      const labelObserver = new MutationObserver(syncFloatingAtc);
      labelObserver.observe(atcBtn, {
        attributes: true,
        attributeFilter: ['disabled'],
        childList: true,
        characterData: true,
        subtree: true,
      });
      syncFloatingAtc();

      // Show the floating button only when the real ATC is off screen. The real
      // button moves between plan anchors, but observing the node itself is
      // unaffected by re-parenting.
      if ('IntersectionObserver' in window) {
        const atcVisibilityObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              floatingAtc.classList.toggle('is-visible', !entry.isIntersecting);
            });
          },
          { root: null, threshold: 0 }
        );
        atcVisibilityObserver.observe(atcBtn);
      } else {
        floatingAtc.classList.add('is-visible');
      }
    }

    // Express Checkout: proxies the real ATC button exactly like the floating
    // ATC above, so device-cap/inventory/bundle-dedup logic is never
    // duplicated. The only difference from a normal ATC click is the
    // fhRedirectTarget flag, read once in finishSuccess and always cleared
    // there / in finishError / on the device-cap early return.
    if (expressBtn && atcBtn) {
      expressBtn.addEventListener('click', () => {
        if (atcBtn.disabled) return;
        // Synchronous, so a rapid double-click can't slip through before the
        // MutationObserver below has a chance to mirror atcBtn's disabled state.
        expressBtn.disabled = true;
        atcBtn.dataset.fhRedirectTarget = 'checkout';
        atcBtn.click();
      });

      const syncExpressBtn = () => {
        expressBtn.disabled = atcBtn.disabled;
      };
      new MutationObserver(syncExpressBtn).observe(atcBtn, {
        attributes: true,
        attributeFilter: ['disabled'],
      });
      syncExpressBtn();
    }

    syncVariant({ dispatchGalleryEvent: false });
    placeAtcButton();
    bindFhDeviceCapCartListeners();
    refreshFhDeviceCapUi();
    }

    document.querySelectorAll('.fh-page[data-section-id]').forEach((root) => {
      const cfgEl = root.querySelector('script[type="application/json"][data-fh-product-config]');
      if (!cfgEl || !cfgEl.textContent.trim()) return;
      let cfg;
      try {
        cfg = JSON.parse(cfgEl.textContent);
      } catch (e) {
        console.warn('[FamilyHubProduct] Invalid product config JSON', e);
        return;
      }
      initFamilyHubProduct(root, cfg);
    });

    /**
     * Hero video: swap the browser's native controls for a GL-designed play/pause
     * button (see website-next AtomicComponents/MediaControlButton). The gallery
     * <video> is injected by the theme's <video-media> element with controls:true;
     * we strip controls and mount our own persistent toggle in the bottom-right.
     * Both icons live in the button; the .fh-video--playing class on <video-media>
     * (driven by the video's play/pause events) swaps which one is visible.
     */
    const FH_PLAY_SVG =
      '<svg class="fh-video-toggle__play" viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
    const FH_PAUSE_SVG =
      '<svg class="fh-video-toggle__pause" viewBox="0 0 24 24" aria-hidden="true"><rect x="6" y="4" width="4" height="16" rx="1"/><rect x="14" y="4" width="4" height="16" rx="1"/></svg>';

    function fhMountVideoToggle(vm, video) {
      if (vm.__fhVideoToggle) return;
      vm.__fhVideoToggle = true;
      video.controls = false;
      video.removeAttribute('controls');

      const btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fh-video-toggle';
      btn.innerHTML = FH_PLAY_SVG + FH_PAUSE_SVG;
      vm.appendChild(btn);

      const sync = () => {
        const playing = !video.paused && !video.ended;
        vm.classList.toggle('fh-video--playing', playing);
        btn.setAttribute(
          'aria-label',
          playing ? 'Pause video' : video.ended ? 'Play again' : 'Play video'
        );
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('ended', sync);
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (video.paused || video.ended) {
          const p = video.play();
          if (p && typeof p.catch === 'function') p.catch(() => {});
        } else {
          video.pause();
        }
      });
      sync();
    }

    function enhanceHeroVideo(root) {
      const gallery = root.querySelector('.fh-gallery');
      if (!gallery) return;
      gallery.querySelectorAll('video-media').forEach((vm) => {
        const existing = vm.querySelector('video');
        if (existing) {
          fhMountVideoToggle(vm, existing);
          return;
        }
        const obs = new MutationObserver(() => {
          const v = vm.querySelector('video');
          if (v) {
            obs.disconnect();
            fhMountVideoToggle(vm, v);
          }
        });
        obs.observe(vm, { childList: true, subtree: true });
      });
    }

    document.querySelectorAll('.fh-page[data-section-id]').forEach(enhanceHeroVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["family-hub-tile-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Mobile only: center the middle (first narrow) column in the
    // horizontal scroller on load/resize, so mobile users land in the
    // middle of the row instead of at the far-left edge. Mirrors the
    // source component's useLayoutEffect + resize listener.
    document.querySelectorAll('[data-fh-tile-grid]').forEach((root) => {
      const scrollEl = root.querySelector('[data-fh-tg-scroll]');
      const middleEl = root.querySelector('[data-fh-tg-middle-col]');
      if (!scrollEl || !middleEl) return;

      const centerMiddleColumn = () => {
        if (window.innerWidth >= 720) {
          scrollEl.scrollLeft = 0;
          return;
        }
        const colCenter = middleEl.offsetLeft + middleEl.offsetWidth / 2;
        const target = colCenter - scrollEl.clientWidth / 2;
        const maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
        scrollEl.scrollLeft = Math.max(0, Math.min(target, maxScroll));
      };

      centerMiddleColumn();
      window.addEventListener('resize', centerMiddleColumn);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fit-check"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-fit-check]').forEach((group) => {
      const options = Array.from(group.querySelectorAll('[data-fit-option]'));
      const result = group.querySelector('[data-fit-result]');
      const verdict = group.querySelector('[data-fit-verdict]');
      const detail = group.querySelector('[data-fit-detail]');
      if (!options.length || !result) return;

      function select(option, focus) {
        options.forEach((other) => {
          const active = other === option;
          other.classList.toggle('is-selected', active);
          other.setAttribute('aria-checked', String(active));
          other.tabIndex = active ? 0 : -1;
        });
        if (verdict) verdict.textContent = option.dataset.verdict || '';
        if (detail) detail.textContent = option.dataset.detail || '';
        result.classList.toggle('is-warning', option.dataset.fits === 'false');
        if (focus) option.focus();
      }

      options.forEach((option, index) => {
        option.addEventListener('click', () => select(option));
        option.addEventListener('keydown', (e) => {
          let delta = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') delta = 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') delta = -1;
          if (!delta) return;
          e.preventDefault();
          select(options[(index + delta + options.length) % options.length], true);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-kids-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function skpdpCartJsonUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
        }
      } catch (_) {}
      return '/cart.js';
    }

    function skpdpCartPageUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url;
        }
      } catch (_) {}
      return '/cart';
    }

    function initSkpdpProduct(root) {
      const cards = Array.from(root.querySelectorAll('[data-skpdp-plan-card]'));
      const atc = root.querySelector('[data-skpdp-atc]');
      if (!atc) return;

      const atcLabel = atc.dataset.atcLabel || 'Add to cart';
      const soldoutLabel = atc.dataset.soldoutLabel || 'Sold out';
      const qtyInput = root.querySelector('[data-skpdp-quantity]');
      const renewalEl = root.querySelector('[data-skpdp-renewal]');
      const renewalDefault = renewalEl ? renewalEl.textContent : '';

      const dynamicCheckoutEnabled = root.dataset.dynamicCheckoutEnabled === 'true';
      const initialVariantId = root.dataset.initialVariantId || '';
      const sectionId = root.dataset.sectionId;
      let dynamicCheckoutTimer = null;
      let dynamicCheckoutAbort = null;
      let dynamicCheckoutToken = 0;

      // Toggles the "stale button" guard — see refreshDynamicCheckout() below.
      function setDynamicCheckoutBusy(busy) {
        root.querySelectorAll('[data-dynamic-checkout-button]').forEach((el) => {
          el.classList.toggle('is-refreshing', busy);
        });
      }

      // Shop Pay / dynamic checkout is a self-contained, closed-shadow-DOM
      // component rendered server-side for whatever variant the form held at
      // render time — Shopify doesn't expose a client-side "retarget" event for
      // it. Re-fetching this section via the Section Rendering API and swapping
      // in the freshly-rendered button markup is the supported way to keep it
      // in sync with a client-side plan change.
      function refreshDynamicCheckout(card) {
        if (!dynamicCheckoutEnabled || !card || !sectionId) return;
        const variantId = card.dataset.variantId;
        if (!variantId) return;

        // The button swap below only lands after a debounce + network round
        // trip, and until then the old button is still fully clickable and
        // still bound to the previous variant. Block input for that whole
        // window, not just the fetch, so a fast click right after a plan
        // change can't slip through and check out the stale plan.
        setDynamicCheckoutBusy(true);

        if (dynamicCheckoutTimer) clearTimeout(dynamicCheckoutTimer);
        dynamicCheckoutTimer = setTimeout(() => {
          if (dynamicCheckoutAbort) dynamicCheckoutAbort.abort();
          dynamicCheckoutAbort = new AbortController();
          const requestToken = ++dynamicCheckoutToken;

          const url = `${window.location.pathname}?variant=${encodeURIComponent(variantId)}&section_id=${encodeURIComponent(sectionId)}`;
          fetch(url, { signal: dynamicCheckoutAbort.signal })
            .then((r) => (r.ok ? r.text() : Promise.reject(r)))
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');

              // The payment button custom element reads its closest form's
              // hidden id input when it (re)connects, rather than anything we
              // pass it directly — swapping only the button markup below left
              // a freshly-connected button instance reading the still-stale,
              // page-load variant id. Sync the input first, from the same
              // fragment the button markup comes from, so the two can never
              // disagree about which variant they belong to.
              const freshIdInputs = Array.from(doc.querySelectorAll('.skpdp-product-form input[name="id"]'));
              const currentIdInputs = Array.from(root.querySelectorAll('.skpdp-product-form input[name="id"]'));
              currentIdInputs.forEach((el, i) => {
                if (freshIdInputs[i]) el.value = freshIdInputs[i].value;
              });

              const fresh = Array.from(doc.querySelectorAll('[data-dynamic-checkout-button]'));
              const current = Array.from(root.querySelectorAll('[data-dynamic-checkout-button]'));
              current.forEach((el, i) => {
                if (fresh[i]) el.innerHTML = fresh[i].innerHTML;
              });
            })
            .catch(() => {})
            .finally(() => {
              // Only the most recent request should clear the busy state —
              // an aborted, superseded request finishing late must not
              // re-enable the button out from under the refresh that
              // replaced it.
              if (requestToken === dynamicCheckoutToken) setDynamicCheckoutBusy(false);
            });
        }, 200);
      }

      function syncAtc(card) {
        if (!card) return;
        const available = card.dataset.available !== 'false';
        atc.dataset.variantId = card.dataset.variantId || '';
        // Expose the selection summary so <sticky-buy-bar> can mirror it.
        atc.dataset.stickyMeta = card.dataset.stickyMeta || '';
        atc.disabled = !available;
        atc.textContent = available ? atcLabel : soldoutLabel;
        // Per-plan renewal wording, when the block supplies an override.
        if (renewalEl) {
          const override = card.dataset.renewal || '';
          renewalEl.textContent = override || renewalDefault;
        }
      }

      function select(card, focus, isInitialRender) {
        cards.forEach((item) => {
          const active = item === card;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-checked', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        syncAtc(card);
        // On the initial auto-select, the server-rendered dynamic checkout
        // button only already matches this card if its variant is the one
        // the server actually rendered (initial_variant) — the featured/
        // pre-selected plan card is NOT guaranteed to be that variant (it's
        // an independent theme-editor setting), so verify instead of
        // assuming. Otherwise the express checkout button silently stays
        // bound to whatever variant the server defaulted to, even though
        // the UI shows a different plan selected.
        const alreadyRendered = isInitialRender && card && card.dataset.variantId === initialVariantId;
        if (!alreadyRendered) refreshDynamicCheckout(card);
        if (focus && card) card.focus();
      }

      cards.forEach((card, index) => {
        card.addEventListener('click', () => select(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            select(card);
            return;
          }
          // Arrow keys move between radios, as a real radio group does.
          let delta = 0;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') delta = 1;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') delta = -1;
          if (!delta) return;
          e.preventDefault();
          const next = cards[(index + delta + cards.length) % cards.length];
          select(next, true);
        });
      });

      // Initialise from the pre-selected (featured) card, else the first card.
      const initial = cards.find((c) => c.classList.contains('is-selected')) || cards[0];
      if (initial) select(initial, false, true);

      atc.addEventListener('click', () => {
        const variantId = Number(atc.dataset.variantId || 0);
        if (!variantId || atc.disabled) return;

        let quantity = 1;
        if (qtyInput) {
          const parsed = parseInt(qtyInput.value, 10);
          if (!isNaN(parsed) && parsed > 0) quantity = parsed;
        }

        const originalLabel = atc.textContent;
        atc.disabled = true;
        atc.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
        })
          .then((r) => (r.ok ? r.json() : Promise.reject(r)))
          .then(() => fetch(skpdpCartJsonUrl()))
          .then((r) => r.json())
          .then((cart) => {
            atc.textContent = originalLabel;
            atc.disabled = false;
            document.querySelectorAll('cart-count').forEach((node) => {
              const display =
                typeof window.fhCartDisplayItemCount === 'function'
                  ? window.fhCartDisplayItemCount(cart)
                  : cart.item_count;
              node.textContent = String(display);
              node.toggleAttribute('hidden', display === 0);
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            // Take the shopper to the cart page instead of relying on a drawer.
            window.location.href = skpdpCartPageUrl();
          })
          .catch(() => {
            atc.textContent = 'Try again';
            atc.disabled = false;
            setTimeout(() => { atc.textContent = originalLabel; }, 1200);
          });
      });
    }

    function moneyFromCents(cents) {
      const value = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(value);
      } catch (_) {
        return '$' + value.toFixed(2);
      }
    }

    function parseMemberConfig(root) {
      try {
        const el = root.querySelector('[data-sf-member-config]');
        if (!el) return { discounts: [] };
        const cfg = JSON.parse(el.textContent);
        return {
          discounts: Array.isArray(cfg.discounts) ? cfg.discounts : [],
        };
      } catch (_) {
        return { discounts: [] };
      }
    }

    function getDiscountCodeCookie() {
      try {
        const match = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
        return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')).trim().toUpperCase() : '';
      } catch (_) {
        return '';
      }
    }

    function matchedMemberDiscount(discounts, cart) {
      if (!discounts.length || !cart) return null;
      const applied = cart.discount_codes || [];
      const byCode = {};
      let lastApplicable = null;
      let lastAny = null;
      for (let i = 0; i < applied.length; i++) {
        const entry = applied[i];
        if (!entry || !entry.code) continue;
        const code = String(entry.code).trim().toUpperCase();
        for (let j = 0; j < discounts.length; j++) {
          if (discounts[j].code !== code) continue;
          byCode[code] = discounts[j];
          lastAny = discounts[j];
          if (entry.applicable !== false) lastApplicable = discounts[j];
        }
      }
      const cookieCode = getDiscountCodeCookie();
      if (cookieCode && byCode[cookieCode]) return byCode[cookieCode];
      return lastApplicable || lastAny;
    }

    function discountedCents(priceCents, compareCents, matched) {
      if (!matched) return priceCents;
      // Percent-off anchors on retail (compare_at) when the offer's `base` is
      // 'retail'; anchors on the customer's current sale price otherwise.
      // Cents-off always comes off the current price — "$X off" means "$X off
      // what you'd otherwise pay," which shouldn't be gated on retail state.
      const base = matched.base === 'retail' ? compareCents : priceCents;
      if (matched.pct > 0) return Math.max(0, Math.round(base * (1 - matched.pct / 100)));
      if (matched.cents > 0) return Math.max(0, priceCents - matched.cents);
      return priceCents;
    }

    function applyMemberPrices(root, matched) {
      const cards = root.querySelectorAll('[data-skpdp-plan-card]');
      cards.forEach((card) => {
        const priceCents = Number(card.dataset.priceCents || 0);
        const compareCents = Number(card.dataset.compareCents || priceCents);
        // The true pre-flash-sale price: a member code replaces an automatic
        // discount at checkout rather than stacking with it (combinesWith:
        // false on both), so its price must be computed off this, not off
        // whatever flash sale has already discounted priceCents/compareCents
        // down to for the no-code default display below.
        const originalPriceCents = Number(card.dataset.originalPriceCents || priceCents);
        const originalCompareCents = Number(card.dataset.originalCompareCents || originalPriceCents);
        const weeks = Number(card.dataset.weeks || 0);
        const mainEl = card.querySelector('[data-skpdp-price-main]');
        const compareEl = card.querySelector('[data-skpdp-price-compare]');
        const badgeEl = card.querySelector('[data-skpdp-member-badge]');
        const flashBadgeEl = card.querySelector('[data-skpdp-flash-badge]');
        const sublineEl = card.querySelector('[data-skpdp-subline]');

        if (matched) {
          // Checkout doesn't let a member code "replace" an automatic
          // discount outright — when two non-combining discounts could both
          // apply, Shopify keeps whichever is more valuable to the customer
          // (confirmed: a flash sale bigger than a test member code stayed
          // applied at checkout). So compare both candidates instead of
          // assuming the code always wins — showing the code's price
          // unconditionally could display a lower number than checkout
          // actually charges.
          const memberCents = discountedCents(originalPriceCents, originalCompareCents, matched);
          const flashCents = priceCents; // already flash-sale-adjusted, or the true price if no flash is active
          const saleCents = Math.min(memberCents, flashCents);
          const memberWins = saleCents === memberCents;

          if (flashBadgeEl) {
            if (!memberWins && card.dataset.flashActive === 'true') flashBadgeEl.removeAttribute('hidden');
            else flashBadgeEl.setAttribute('hidden', '');
          }
          if (mainEl) mainEl.textContent = moneyFromCents(saleCents);
          if (compareEl) {
            compareEl.textContent = moneyFromCents(originalCompareCents);
            compareEl.removeAttribute('hidden');
          }
          if (badgeEl) {
            if (memberWins) badgeEl.removeAttribute('hidden');
            else badgeEl.setAttribute('hidden', '');
          }
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(saleCents / weeks));
            const save = moneyFromCents(Math.max(0, originalCompareCents - saleCents));
            sublineEl.innerHTML =
              'Just ' + weekly + '/week • <span class="skpdp-save">Save ' + save + '</span>';
          }
          const title = (card.querySelector('.skpdp-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(saleCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(saleCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        } else {
          if (flashBadgeEl) {
            if (card.dataset.flashActive === 'true') flashBadgeEl.removeAttribute('hidden');
            else flashBadgeEl.setAttribute('hidden', '');
          }
          if (mainEl) mainEl.textContent = moneyFromCents(priceCents);
          if (compareEl) {
            if (compareCents > priceCents) {
              compareEl.textContent = moneyFromCents(compareCents);
              compareEl.removeAttribute('hidden');
            } else {
              compareEl.textContent = '';
              compareEl.setAttribute('hidden', '');
            }
          }
          if (badgeEl) badgeEl.setAttribute('hidden', '');
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(priceCents / weeks));
            if (compareCents > priceCents) {
              sublineEl.innerHTML =
                'Just ' +
                weekly +
                '/week • <span class="skpdp-save">Save ' +
                moneyFromCents(compareCents - priceCents) +
                '</span>';
            } else {
              sublineEl.textContent = 'Just ' + weekly + '/week';
            }
          }
          const title = (card.querySelector('.skpdp-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(priceCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(priceCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        }
      });

      // Keep ATC sticky meta in sync with the selected card.
      const selected = root.querySelector('[data-skpdp-plan-card].is-selected');
      const atc = root.querySelector('[data-skpdp-atc]');
      if (selected && atc) atc.dataset.stickyMeta = selected.dataset.stickyMeta || '';
    }

    function initSkpdpMemberOffer(root) {
      const { discounts } = parseMemberConfig(root);
      if (!discounts.length && !root.hasAttribute('data-sf-member-root')) return;

      function refreshFromCart(cart) {
        applyMemberPrices(root, matchedMemberDiscount(discounts, cart));
      }

      function pullCart() {
        return fetch(skpdpCartJsonUrl())
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (cart) refreshFromCart(cart);
          })
          .catch(() => {});
      }

      pullCart();
      document.addEventListener('sf:member-offer', () => pullCart());
      document.addEventListener('cart:updated', (e) => {
        if (e && e.detail && e.detail.cart) refreshFromCart(e.detail.cart);
        else pullCart();
      });
      document.addEventListener('cart:refresh', () => pullCart());
    }

    document.querySelectorAll('.skpdp-page[data-section-id]').forEach((root) => {
      initSkpdpProduct(root);
      initSkpdpMemberOffer(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-kids-tracker-product-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function skt2CartJsonUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
        }
      } catch (_) {}
      return '/cart.js';
    }

    function skt2CartPageUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url;
        }
      } catch (_) {}
      return '/cart';
    }

    function initSkt2Product(root) {
      const cards = Array.from(root.querySelectorAll('[data-skt2-plan-card]'));
      const atc = root.querySelector('[data-skt2-atc]');
      if (!atc) return;

      const atcLabel = atc.dataset.atcLabel || 'Add to cart';
      const soldoutLabel = atc.dataset.soldoutLabel || 'Sold out';

      function syncAtc(card) {
        if (!card) return;
        const available = card.dataset.available !== 'false';
        atc.dataset.variantId = card.dataset.variantId || '';
        // Expose the selection summary so <sticky-buy-bar> can mirror it.
        atc.dataset.stickyMeta = card.dataset.stickyMeta || '';
        atc.disabled = !available;
        atc.textContent = available ? atcLabel : soldoutLabel;
      }

      function select(card) {
        cards.forEach((item) => {
          const active = item === card;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-checked', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        syncAtc(card);
      }

      cards.forEach((card) => {
        card.addEventListener('click', () => select(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            select(card);
          }
        });
      });

      // Initialise from the pre-selected (featured) card, else the first card.
      const initial = cards.find((c) => c.classList.contains('is-selected')) || cards[0];
      if (initial) select(initial);

      atc.addEventListener('click', () => {
        const variantId = Number(atc.dataset.variantId || 0);
        if (!variantId || atc.disabled) return;

        const originalLabel = atc.textContent;
        atc.disabled = true;
        atc.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then((r) => (r.ok ? r.json() : Promise.reject(r)))
          .then(() => fetch(skt2CartJsonUrl()))
          .then((r) => r.json())
          .then((cart) => {
            atc.textContent = originalLabel;
            atc.disabled = false;
            document.querySelectorAll('cart-count').forEach((node) => {
              const display =
                typeof window.fhCartDisplayItemCount === 'function'
                  ? window.fhCartDisplayItemCount(cart)
                  : cart.item_count;
              node.textContent = String(display);
              node.toggleAttribute('hidden', display === 0);
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            // Take the shopper to the cart page instead of relying on a drawer.
            window.location.href = skt2CartPageUrl();
          })
          .catch(() => {
            atc.textContent = 'Try again';
            atc.disabled = false;
            setTimeout(() => { atc.textContent = originalLabel; }, 1200);
          });
      });
    }

    function moneyFromCents(cents) {
      const value = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(value);
      } catch (_) {
        return '$' + value.toFixed(2);
      }
    }

    function parseMemberConfig(root) {
      try {
        const el = root.querySelector('[data-sf-member-config]');
        if (!el) return { discounts: [] };
        const cfg = JSON.parse(el.textContent);
        return {
          discounts: Array.isArray(cfg.discounts) ? cfg.discounts : [],
        };
      } catch (_) {
        return { discounts: [] };
      }
    }

    function getDiscountCodeCookie() {
      try {
        const match = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
        return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')).trim().toUpperCase() : '';
      } catch (_) {
        return '';
      }
    }

    function matchedMemberDiscount(discounts, cart) {
      if (!discounts.length || !cart) return null;
      const applied = cart.discount_codes || [];
      const byCode = {};
      let lastApplicable = null;
      let lastAny = null;
      for (let i = 0; i < applied.length; i++) {
        const entry = applied[i];
        if (!entry || !entry.code) continue;
        const code = String(entry.code).trim().toUpperCase();
        for (let j = 0; j < discounts.length; j++) {
          if (discounts[j].code !== code) continue;
          byCode[code] = discounts[j];
          lastAny = discounts[j];
          if (entry.applicable !== false) lastApplicable = discounts[j];
        }
      }
      const cookieCode = getDiscountCodeCookie();
      if (cookieCode && byCode[cookieCode]) return byCode[cookieCode];
      return lastApplicable || lastAny;
    }

    function discountedCents(priceCents, compareCents, matched) {
      if (!matched) return priceCents;
      // Percent-off anchors on retail (compare_at) when the offer's `base` is
      // 'retail'; anchors on the customer's current sale price otherwise.
      // Cents-off always comes off the current price — "$X off" means "$X off
      // what you'd otherwise pay," which shouldn't be gated on retail state.
      const base = matched.base === 'retail' ? compareCents : priceCents;
      if (matched.pct > 0) return Math.max(0, Math.round(base * (1 - matched.pct / 100)));
      if (matched.cents > 0) return Math.max(0, priceCents - matched.cents);
      return priceCents;
    }

    function applyMemberPrices(root, matched) {
      const cards = root.querySelectorAll('[data-skt2-plan-card]');
      cards.forEach((card) => {
        const priceCents = Number(card.dataset.priceCents || 0);
        const compareCents = Number(card.dataset.compareCents || priceCents);
        const weeks = Number(card.dataset.weeks || 0);
        const mainEl = card.querySelector('[data-skt2-price-main]');
        const compareEl = card.querySelector('[data-skt2-price-compare]');
        const badgeEl = card.querySelector('[data-skt2-member-badge]');
        const sublineEl = card.querySelector('[data-skt2-subline]');

        if (matched) {
          const saleCents = discountedCents(priceCents, compareCents, matched);
          if (mainEl) mainEl.textContent = moneyFromCents(saleCents);
          if (compareEl) {
            compareEl.textContent = moneyFromCents(compareCents);
            compareEl.removeAttribute('hidden');
          }
          if (badgeEl) badgeEl.removeAttribute('hidden');
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(saleCents / weeks));
            const save = moneyFromCents(Math.max(0, compareCents - saleCents));
            sublineEl.innerHTML =
              'Equals to ' + weekly + '/week • <span class="skt2-save">Save ' + save + '</span>';
          }
          const title = (card.querySelector('.skt2-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(saleCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(saleCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        } else {
          if (mainEl) mainEl.textContent = moneyFromCents(priceCents);
          if (compareEl) {
            if (compareCents > priceCents) {
              compareEl.textContent = moneyFromCents(compareCents);
              compareEl.removeAttribute('hidden');
            } else {
              compareEl.textContent = '';
              compareEl.setAttribute('hidden', '');
            }
          }
          if (badgeEl) badgeEl.setAttribute('hidden', '');
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(priceCents / weeks));
            if (compareCents > priceCents) {
              sublineEl.innerHTML =
                'Equals to ' +
                weekly +
                '/week • <span class="skt2-save">Save ' +
                moneyFromCents(compareCents - priceCents) +
                '</span>';
            } else {
              sublineEl.textContent = 'Equals to ' + weekly + '/week';
            }
          }
          const title = (card.querySelector('.skt2-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(priceCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(priceCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        }
      });

      // Keep ATC sticky meta in sync with the selected card.
      const selected = root.querySelector('[data-skt2-plan-card].is-selected');
      const atc = root.querySelector('[data-skt2-atc]');
      if (selected && atc) atc.dataset.stickyMeta = selected.dataset.stickyMeta || '';
    }

    function initSkt2MemberOffer(root) {
      const { discounts } = parseMemberConfig(root);
      if (!discounts.length && !root.hasAttribute('data-sf-member-root')) return;

      function refreshFromCart(cart) {
        applyMemberPrices(root, matchedMemberDiscount(discounts, cart));
      }

      function pullCart() {
        return fetch(skt2CartJsonUrl())
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (cart) refreshFromCart(cart);
          })
          .catch(() => {});
      }

      pullCart();
      document.addEventListener('sf:member-offer', () => pullCart());
      document.addEventListener('cart:updated', (e) => {
        if (e && e.detail && e.detail.cart) refreshFromCart(e.detail.cart);
        else pullCart();
      });
      document.addEventListener('cart:refresh', () => pullCart());
    }

    document.querySelectorAll('.skt2-page[data-section-id]').forEach((root) => {
      initSkt2Product(root);
      initSkt2MemberOffer(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-kids-tracker-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function sktCartJsonUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
        }
      } catch (_) {}
      return '/cart.js';
    }

    function sktCartPageUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url;
        }
      } catch (_) {}
      return '/cart';
    }

    function initSktProduct(root) {
      const cards = root.querySelectorAll('[data-skt-plan-card]');
      const atcButtons = root.querySelectorAll('[data-skt-atc]');

      // Card selection is cosmetic — each card's own ATC adds its variant.
      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('[data-skt-atc]')) return;
          cards.forEach((item) => {
            const active = item === card;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-checked', String(active));
            item.tabIndex = active ? 0 : -1;
          });
        });
      });

      atcButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const variantId = Number(btn.dataset.variantId || 0);
          if (!variantId || btn.disabled) return;

          // Reflect the chosen card as selected.
          const ownCard = btn.closest('[data-skt-plan-card]');
          if (ownCard) {
            cards.forEach((item) => {
              const active = item === ownCard;
              item.classList.toggle('is-selected', active);
              item.setAttribute('aria-checked', String(active));
            });
          }

          const originalLabel = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          })
            .then((r) => (r.ok ? r.json() : Promise.reject(r)))
            .then(() => fetch(sktCartJsonUrl()))
            .then((r) => r.json())
            .then((cart) => {
              btn.textContent = originalLabel;
              btn.disabled = false;
              document.querySelectorAll('cart-count').forEach((node) => {
                const display =
                  typeof window.fhCartDisplayItemCount === 'function'
                    ? window.fhCartDisplayItemCount(cart)
                    : cart.item_count;
                node.textContent = String(display);
                node.toggleAttribute('hidden', display === 0);
              });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
              // Take the shopper to the cart page instead of relying on a drawer.
              window.location.href = sktCartPageUrl();
            })
            .catch(() => {
              btn.textContent = 'Try again';
              btn.disabled = false;
              setTimeout(() => { btn.textContent = originalLabel; }, 1200);
            });
        });
      });
    }

    document.querySelectorAll('.skt-page[data-section-id]').forEach(initSktProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-pets-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function sppdpCartJsonUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
        }
      } catch (_) {}
      return '/cart.js';
    }

    function sppdpCartPageUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url;
        }
      } catch (_) {}
      return '/cart';
    }

    function initSppdpProduct(root) {
      const cards = Array.from(root.querySelectorAll('[data-sppdp-plan-card]'));
      const atc = root.querySelector('[data-sppdp-atc]');
      if (!atc) return;

      const atcLabel = atc.dataset.atcLabel || 'Add to cart';
      const soldoutLabel = atc.dataset.soldoutLabel || 'Sold out';
      const qtyInput = root.querySelector('[data-sppdp-quantity]');
      const renewalEl = root.querySelector('[data-sppdp-renewal]');
      const renewalDefault = renewalEl ? renewalEl.textContent : '';

      function syncAtc(card) {
        if (!card) return;
        const available = card.dataset.available !== 'false';
        atc.dataset.variantId = card.dataset.variantId || '';
        // Expose the selection summary so <sticky-buy-bar> can mirror it.
        atc.dataset.stickyMeta = card.dataset.stickyMeta || '';
        atc.disabled = !available;
        atc.textContent = available ? atcLabel : soldoutLabel;
        // Per-plan renewal wording, when the block supplies an override.
        if (renewalEl) {
          const override = card.dataset.renewal || '';
          renewalEl.textContent = override || renewalDefault;
        }
      }

      function select(card, focus) {
        cards.forEach((item) => {
          const active = item === card;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-checked', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        syncAtc(card);
        if (focus && card) card.focus();
      }

      cards.forEach((card, index) => {
        card.addEventListener('click', () => select(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            select(card);
            return;
          }
          // Arrow keys move between radios, as a real radio group does.
          let delta = 0;
          if (e.key === 'ArrowDown' || e.key === 'ArrowRight') delta = 1;
          if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') delta = -1;
          if (!delta) return;
          e.preventDefault();
          const next = cards[(index + delta + cards.length) % cards.length];
          select(next, true);
        });
      });

      // Initialise from the pre-selected (featured) card, else the first card.
      const initial = cards.find((c) => c.classList.contains('is-selected')) || cards[0];
      if (initial) select(initial);

      atc.addEventListener('click', () => {
        const variantId = Number(atc.dataset.variantId || 0);
        if (!variantId || atc.disabled) return;

        let quantity = 1;
        if (qtyInput) {
          const parsed = parseInt(qtyInput.value, 10);
          if (!isNaN(parsed) && parsed > 0) quantity = parsed;
        }

        const originalLabel = atc.textContent;
        atc.disabled = true;
        atc.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] }),
        })
          .then((r) => (r.ok ? r.json() : Promise.reject(r)))
          .then(() => fetch(sppdpCartJsonUrl()))
          .then((r) => r.json())
          .then((cart) => {
            atc.textContent = originalLabel;
            atc.disabled = false;
            document.querySelectorAll('cart-count').forEach((node) => {
              const display =
                typeof window.fhCartDisplayItemCount === 'function'
                  ? window.fhCartDisplayItemCount(cart)
                  : cart.item_count;
              node.textContent = String(display);
              node.toggleAttribute('hidden', display === 0);
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            // Take the shopper to the cart page instead of relying on a drawer.
            window.location.href = sppdpCartPageUrl();
          })
          .catch(() => {
            atc.textContent = 'Try again';
            atc.disabled = false;
            setTimeout(() => { atc.textContent = originalLabel; }, 1200);
          });
      });
    }

    function moneyFromCents(cents) {
      const value = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(value);
      } catch (_) {
        return '$' + value.toFixed(2);
      }
    }

    function parseMemberConfig(root) {
      try {
        const el = root.querySelector('[data-sf-member-config]');
        if (!el) return { discounts: [] };
        const cfg = JSON.parse(el.textContent);
        return {
          discounts: Array.isArray(cfg.discounts) ? cfg.discounts : [],
        };
      } catch (_) {
        return { discounts: [] };
      }
    }

    function getDiscountCodeCookie() {
      try {
        const match = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
        return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')).trim().toUpperCase() : '';
      } catch (_) {
        return '';
      }
    }

    function matchedMemberDiscount(discounts, cart) {
      if (!discounts.length || !cart) return null;
      const applied = cart.discount_codes || [];
      const byCode = {};
      let lastApplicable = null;
      let lastAny = null;
      for (let i = 0; i < applied.length; i++) {
        const entry = applied[i];
        if (!entry || !entry.code) continue;
        const code = String(entry.code).trim().toUpperCase();
        for (let j = 0; j < discounts.length; j++) {
          if (discounts[j].code !== code) continue;
          byCode[code] = discounts[j];
          lastAny = discounts[j];
          if (entry.applicable !== false) lastApplicable = discounts[j];
        }
      }
      const cookieCode = getDiscountCodeCookie();
      if (cookieCode && byCode[cookieCode]) return byCode[cookieCode];
      return lastApplicable || lastAny;
    }

    function discountedCents(priceCents, compareCents, matched) {
      if (!matched) return priceCents;
      // Percent-off anchors on retail (compare_at) when the offer's `base` is
      // 'retail'; anchors on the customer's current sale price otherwise.
      // Cents-off always comes off the current price — "$X off" means "$X off
      // what you'd otherwise pay," which shouldn't be gated on retail state.
      const base = matched.base === 'retail' ? compareCents : priceCents;
      if (matched.pct > 0) return Math.max(0, Math.round(base * (1 - matched.pct / 100)));
      if (matched.cents > 0) return Math.max(0, priceCents - matched.cents);
      return priceCents;
    }

    function applyMemberPrices(root, matched) {
      const cards = root.querySelectorAll('[data-sppdp-plan-card]');
      cards.forEach((card) => {
        const priceCents = Number(card.dataset.priceCents || 0);
        const compareCents = Number(card.dataset.compareCents || priceCents);
        const weeks = Number(card.dataset.weeks || 0);
        const mainEl = card.querySelector('[data-sppdp-price-main]');
        const compareEl = card.querySelector('[data-sppdp-price-compare]');
        const badgeEl = card.querySelector('[data-sppdp-member-badge]');
        const sublineEl = card.querySelector('[data-sppdp-subline]');

        if (matched) {
          const saleCents = discountedCents(priceCents, compareCents, matched);
          if (mainEl) mainEl.textContent = moneyFromCents(saleCents);
          if (compareEl) {
            compareEl.textContent = moneyFromCents(compareCents);
            compareEl.removeAttribute('hidden');
          }
          if (badgeEl) badgeEl.removeAttribute('hidden');
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(saleCents / weeks));
            const save = moneyFromCents(Math.max(0, compareCents - saleCents));
            sublineEl.innerHTML =
              'Just ' + weekly + '/week • <span class="sppdp-save">Save ' + save + '</span>';
          }
          const title = (card.querySelector('.sppdp-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(saleCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(saleCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        } else {
          if (mainEl) mainEl.textContent = moneyFromCents(priceCents);
          if (compareEl) {
            if (compareCents > priceCents) {
              compareEl.textContent = moneyFromCents(compareCents);
              compareEl.removeAttribute('hidden');
            } else {
              compareEl.textContent = '';
              compareEl.setAttribute('hidden', '');
            }
          }
          if (badgeEl) badgeEl.setAttribute('hidden', '');
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(priceCents / weeks));
            if (compareCents > priceCents) {
              sublineEl.innerHTML =
                'Just ' +
                weekly +
                '/week • <span class="sppdp-save">Save ' +
                moneyFromCents(compareCents - priceCents) +
                '</span>';
            } else {
              sublineEl.textContent = 'Just ' + weekly + '/week';
            }
          }
          const title = (card.querySelector('.sppdp-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(priceCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(priceCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        }
      });

      // Keep ATC sticky meta in sync with the selected card.
      const selected = root.querySelector('[data-sppdp-plan-card].is-selected');
      const atc = root.querySelector('[data-sppdp-atc]');
      if (selected && atc) atc.dataset.stickyMeta = selected.dataset.stickyMeta || '';
    }

    function initSppdpMemberOffer(root) {
      const { discounts } = parseMemberConfig(root);
      if (!discounts.length && !root.hasAttribute('data-sf-member-root')) return;

      function refreshFromCart(cart) {
        applyMemberPrices(root, matchedMemberDiscount(discounts, cart));
      }

      function pullCart() {
        return fetch(sppdpCartJsonUrl())
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (cart) refreshFromCart(cart);
          })
          .catch(() => {});
      }

      pullCart();
      document.addEventListener('sf:member-offer', () => pullCart());
      document.addEventListener('cart:updated', (e) => {
        if (e && e.detail && e.detail.cart) refreshFromCart(e.detail.cart);
        else pullCart();
      });
      document.addEventListener('cart:refresh', () => pullCart());
    }

    function initSppdpCollar(root) {
      const group = root.querySelector('[data-sppdp-collar]');
      if (!group) return;
      const options = Array.from(group.querySelectorAll('[data-sppdp-collar-option]'));
      const verdict = group.querySelector('[data-sppdp-collar-verdict]');
      if (!options.length || !verdict) return;

      function select(option, focus) {
        options.forEach((other) => {
          const active = other === option;
          other.classList.toggle('is-selected', active);
          other.setAttribute('aria-checked', String(active));
          other.tabIndex = active ? 0 : -1;
        });
        verdict.textContent = option.dataset.verdict || '';
        verdict.classList.toggle('is-warning', option.dataset.fits === 'false');
        if (focus) option.focus();
      }

      options.forEach((option, index) => {
        option.addEventListener('click', () => select(option));
        option.addEventListener('keydown', (e) => {
          let delta = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') delta = 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') delta = -1;
          if (!delta) return;
          e.preventDefault();
          select(options[(index + delta + options.length) % options.length], true);
        });
      });
    }

    document.querySelectorAll('.sppdp-page[data-section-id]').forEach((root) => {
      initSppdpProduct(root);
      initSppdpMemberOffer(root);
      initSppdpCollar(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-pets-tracker-product-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function spt2CartJsonUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
        }
      } catch (_) {}
      return '/cart.js';
    }

    function spt2CartPageUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url;
        }
      } catch (_) {}
      return '/cart';
    }

    function initSpt2Product(root) {
      const cards = Array.from(root.querySelectorAll('[data-spt2-plan-card]'));
      const atc = root.querySelector('[data-spt2-atc]');
      if (!atc) return;

      const atcLabel = atc.dataset.atcLabel || 'Add to cart';
      const soldoutLabel = atc.dataset.soldoutLabel || 'Sold out';

      function syncAtc(card) {
        if (!card) return;
        const available = card.dataset.available !== 'false';
        atc.dataset.variantId = card.dataset.variantId || '';
        // Expose the selection summary so <sticky-buy-bar> can mirror it.
        atc.dataset.stickyMeta = card.dataset.stickyMeta || '';
        atc.disabled = !available;
        atc.textContent = available ? atcLabel : soldoutLabel;
      }

      function select(card) {
        cards.forEach((item) => {
          const active = item === card;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-checked', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        syncAtc(card);
      }

      cards.forEach((card) => {
        card.addEventListener('click', () => select(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            select(card);
          }
        });
      });

      // Initialise from the pre-selected (featured) card, else the first card.
      const initial = cards.find((c) => c.classList.contains('is-selected')) || cards[0];
      if (initial) select(initial);

      atc.addEventListener('click', () => {
        const variantId = Number(atc.dataset.variantId || 0);
        if (!variantId || atc.disabled) return;

        const originalLabel = atc.textContent;
        atc.disabled = true;
        atc.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then((r) => (r.ok ? r.json() : Promise.reject(r)))
          .then(() => fetch(spt2CartJsonUrl()))
          .then((r) => r.json())
          .then((cart) => {
            atc.textContent = originalLabel;
            atc.disabled = false;
            document.querySelectorAll('cart-count').forEach((node) => {
              const display =
                typeof window.fhCartDisplayItemCount === 'function'
                  ? window.fhCartDisplayItemCount(cart)
                  : cart.item_count;
              node.textContent = String(display);
              node.toggleAttribute('hidden', display === 0);
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            // Take the shopper to the cart page instead of relying on a drawer.
            window.location.href = spt2CartPageUrl();
          })
          .catch(() => {
            atc.textContent = 'Try again';
            atc.disabled = false;
            setTimeout(() => { atc.textContent = originalLabel; }, 1200);
          });
      });
    }

    function moneyFromCents(cents) {
      const value = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(value);
      } catch (_) {
        return '$' + value.toFixed(2);
      }
    }

    function parseMemberConfig(root) {
      try {
        const el = root.querySelector('[data-sf-member-config]');
        if (!el) return { discounts: [] };
        const cfg = JSON.parse(el.textContent);
        return {
          discounts: Array.isArray(cfg.discounts) ? cfg.discounts : [],
        };
      } catch (_) {
        return { discounts: [] };
      }
    }

    function getDiscountCodeCookie() {
      try {
        const match = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
        return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')).trim().toUpperCase() : '';
      } catch (_) {
        return '';
      }
    }

    function matchedMemberDiscount(discounts, cart) {
      if (!discounts.length || !cart) return null;
      const applied = cart.discount_codes || [];
      const byCode = {};
      let lastApplicable = null;
      let lastAny = null;
      for (let i = 0; i < applied.length; i++) {
        const entry = applied[i];
        if (!entry || !entry.code) continue;
        const code = String(entry.code).trim().toUpperCase();
        for (let j = 0; j < discounts.length; j++) {
          if (discounts[j].code !== code) continue;
          byCode[code] = discounts[j];
          lastAny = discounts[j];
          if (entry.applicable !== false) lastApplicable = discounts[j];
        }
      }
      const cookieCode = getDiscountCodeCookie();
      if (cookieCode && byCode[cookieCode]) return byCode[cookieCode];
      return lastApplicable || lastAny;
    }

    function discountedCents(priceCents, compareCents, matched) {
      if (!matched) return priceCents;
      // Percent-off anchors on retail (compare_at) when the offer's `base` is
      // 'retail'; anchors on the customer's current sale price otherwise.
      // Cents-off always comes off the current price — "$X off" means "$X off
      // what you'd otherwise pay," which shouldn't be gated on retail state.
      const base = matched.base === 'retail' ? compareCents : priceCents;
      if (matched.pct > 0) return Math.max(0, Math.round(base * (1 - matched.pct / 100)));
      if (matched.cents > 0) return Math.max(0, priceCents - matched.cents);
      return priceCents;
    }

    function applyMemberPrices(root, matched) {
      const cards = root.querySelectorAll('[data-spt2-plan-card]');
      cards.forEach((card) => {
        const priceCents = Number(card.dataset.priceCents || 0);
        const compareCents = Number(card.dataset.compareCents || priceCents);
        // The true pre-flash-sale price: a member code replaces an automatic
        // discount at checkout rather than stacking with it (combinesWith:
        // false on both), so its price must be computed off this, not off
        // whatever flash sale has already discounted priceCents/compareCents
        // down to for the no-code default display below.
        const originalPriceCents = Number(card.dataset.originalPriceCents || priceCents);
        const originalCompareCents = Number(card.dataset.originalCompareCents || originalPriceCents);
        const weeks = Number(card.dataset.weeks || 0);
        const mainEl = card.querySelector('[data-spt2-price-main]');
        const compareEl = card.querySelector('[data-spt2-price-compare]');
        const badgeEl = card.querySelector('[data-spt2-member-badge]');
        const flashBadgeEl = card.querySelector('[data-spt2-flash-badge]');
        const sublineEl = card.querySelector('[data-spt2-subline]');

        if (matched) {
          // Checkout doesn't let a member code "replace" an automatic
          // discount outright — when two non-combining discounts could both
          // apply, Shopify keeps whichever is more valuable to the customer
          // (confirmed: a flash sale bigger than a test member code stayed
          // applied at checkout). So compare both candidates instead of
          // assuming the code always wins — showing the code's price
          // unconditionally could display a lower number than checkout
          // actually charges.
          const memberCents = discountedCents(originalPriceCents, originalCompareCents, matched);
          const flashCents = priceCents; // already flash-sale-adjusted, or the true price if no flash is active
          const saleCents = Math.min(memberCents, flashCents);
          const memberWins = saleCents === memberCents;

          if (flashBadgeEl) {
            if (!memberWins && card.dataset.flashActive === 'true') flashBadgeEl.removeAttribute('hidden');
            else flashBadgeEl.setAttribute('hidden', '');
          }
          if (mainEl) mainEl.textContent = moneyFromCents(saleCents);
          if (compareEl) {
            compareEl.textContent = moneyFromCents(originalCompareCents);
            compareEl.removeAttribute('hidden');
          }
          if (badgeEl) {
            if (memberWins) badgeEl.removeAttribute('hidden');
            else badgeEl.setAttribute('hidden', '');
          }
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(saleCents / weeks));
            const save = moneyFromCents(Math.max(0, originalCompareCents - saleCents));
            sublineEl.innerHTML =
              'Equals to ' + weekly + '/week • <span class="spt2-save">Save ' + save + '</span>';
          }
          const title = (card.querySelector('.spt2-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(saleCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(saleCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        } else {
          if (flashBadgeEl) {
            if (card.dataset.flashActive === 'true') flashBadgeEl.removeAttribute('hidden');
            else flashBadgeEl.setAttribute('hidden', '');
          }
          if (mainEl) mainEl.textContent = moneyFromCents(priceCents);
          if (compareEl) {
            if (compareCents > priceCents) {
              compareEl.textContent = moneyFromCents(compareCents);
              compareEl.removeAttribute('hidden');
            } else {
              compareEl.textContent = '';
              compareEl.setAttribute('hidden', '');
            }
          }
          if (badgeEl) badgeEl.setAttribute('hidden', '');
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(priceCents / weeks));
            if (compareCents > priceCents) {
              sublineEl.innerHTML =
                'Equals to ' +
                weekly +
                '/week • <span class="spt2-save">Save ' +
                moneyFromCents(compareCents - priceCents) +
                '</span>';
            } else {
              sublineEl.textContent = 'Equals to ' + weekly + '/week';
            }
          }
          const title = (card.querySelector('.spt2-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(priceCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(priceCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        }
      });

      // Keep ATC sticky meta in sync with the selected card.
      const selected = root.querySelector('[data-spt2-plan-card].is-selected');
      const atc = root.querySelector('[data-spt2-atc]');
      if (selected && atc) atc.dataset.stickyMeta = selected.dataset.stickyMeta || '';
    }

    function initSpt2MemberOffer(root) {
      const { discounts } = parseMemberConfig(root);
      if (!discounts.length && !root.hasAttribute('data-sf-member-root')) return;

      function refreshFromCart(cart) {
        applyMemberPrices(root, matchedMemberDiscount(discounts, cart));
      }

      function pullCart() {
        return fetch(spt2CartJsonUrl())
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (cart) refreshFromCart(cart);
          })
          .catch(() => {});
      }

      pullCart();
      document.addEventListener('sf:member-offer', () => pullCart());
      document.addEventListener('cart:updated', (e) => {
        if (e && e.detail && e.detail.cart) refreshFromCart(e.detail.cart);
        else pullCart();
      });
      document.addEventListener('cart:refresh', () => pullCart());
    }

    document.querySelectorAll('.spt2-page[data-section-id]').forEach((root) => {
      initSpt2Product(root);
      initSpt2MemberOffer(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-pets-tracker-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function sptCartJsonUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
        }
      } catch (_) {}
      return '/cart.js';
    }

    function sptCartPageUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url;
        }
      } catch (_) {}
      return '/cart';
    }

    function initSptProduct(root) {
      const cards = root.querySelectorAll('[data-spt-plan-card]');
      const atcButtons = root.querySelectorAll('[data-spt-atc]');

      // Card selection is cosmetic — each card's own ATC adds its variant.
      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('[data-spt-atc]')) return;
          cards.forEach((item) => {
            const active = item === card;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-checked', String(active));
            item.tabIndex = active ? 0 : -1;
          });
        });
      });

      atcButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const variantId = Number(btn.dataset.variantId || 0);
          if (!variantId || btn.disabled) return;

          // Reflect the chosen card as selected.
          const ownCard = btn.closest('[data-spt-plan-card]');
          if (ownCard) {
            cards.forEach((item) => {
              const active = item === ownCard;
              item.classList.toggle('is-selected', active);
              item.setAttribute('aria-checked', String(active));
            });
          }

          const originalLabel = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          })
            .then((r) => (r.ok ? r.json() : Promise.reject(r)))
            .then(() => fetch(sptCartJsonUrl()))
            .then((r) => r.json())
            .then((cart) => {
              btn.textContent = originalLabel;
              btn.disabled = false;
              document.querySelectorAll('cart-count').forEach((node) => {
                const display =
                  typeof window.fhCartDisplayItemCount === 'function'
                    ? window.fhCartDisplayItemCount(cart)
                    : cart.item_count;
                node.textContent = String(display);
                node.toggleAttribute('hidden', display === 0);
              });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
              // Take the shopper to the cart page instead of relying on a drawer.
              window.location.href = sptCartPageUrl();
            })
            .catch(() => {
              btn.textContent = 'Try again';
              btn.disabled = false;
              setTimeout(() => { btn.textContent = originalLabel; }, 1200);
            });
        });
      });
    }

    document.querySelectorAll('.spt-page[data-section-id]').forEach(initSptProduct);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-seniors-tracker-product-v2"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function sst2CartJsonUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
        }
      } catch (_) {}
      return '/cart.js';
    }

    function sst2CartPageUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url;
        }
      } catch (_) {}
      return '/cart';
    }

    function initSst2Product(root) {
      const cards = Array.from(root.querySelectorAll('[data-sst2-plan-card]'));
      const atc = root.querySelector('[data-sst2-atc]');
      if (!atc) return;

      const atcLabel = atc.dataset.atcLabel || 'Add to cart';
      const soldoutLabel = atc.dataset.soldoutLabel || 'Sold out';

      function syncAtc(card) {
        if (!card) return;
        const available = card.dataset.available !== 'false';
        atc.dataset.variantId = card.dataset.variantId || '';
        // Expose the selection summary so <sticky-buy-bar> can mirror it.
        atc.dataset.stickyMeta = card.dataset.stickyMeta || '';
        atc.disabled = !available;
        atc.textContent = available ? atcLabel : soldoutLabel;
      }

      function select(card) {
        cards.forEach((item) => {
          const active = item === card;
          item.classList.toggle('is-selected', active);
          item.setAttribute('aria-checked', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        syncAtc(card);
      }

      cards.forEach((card) => {
        card.addEventListener('click', () => select(card));
        card.addEventListener('keydown', (e) => {
          if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            select(card);
          }
        });
      });

      // Initialise from the pre-selected (featured) card, else the first card.
      const initial = cards.find((c) => c.classList.contains('is-selected')) || cards[0];
      if (initial) select(initial);

      atc.addEventListener('click', () => {
        const variantId = Number(atc.dataset.variantId || 0);
        if (!variantId || atc.disabled) return;

        const originalLabel = atc.textContent;
        atc.disabled = true;
        atc.textContent = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
        })
          .then((r) => (r.ok ? r.json() : Promise.reject(r)))
          .then(() => fetch(sst2CartJsonUrl()))
          .then((r) => r.json())
          .then((cart) => {
            atc.textContent = originalLabel;
            atc.disabled = false;
            document.querySelectorAll('cart-count').forEach((node) => {
              const display =
                typeof window.fhCartDisplayItemCount === 'function'
                  ? window.fhCartDisplayItemCount(cart)
                  : cart.item_count;
              node.textContent = String(display);
              node.toggleAttribute('hidden', display === 0);
            });
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
            // Take the shopper to the cart page instead of relying on a drawer.
            window.location.href = sst2CartPageUrl();
          })
          .catch(() => {
            atc.textContent = 'Try again';
            atc.disabled = false;
            setTimeout(() => { atc.textContent = originalLabel; }, 1200);
          });
      });
    }

    function moneyFromCents(cents) {
      const value = (Number(cents) || 0) / 100;
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(value);
      } catch (_) {
        return '$' + value.toFixed(2);
      }
    }

    function parseMemberConfig(root) {
      try {
        const el = root.querySelector('[data-sf-member-config]');
        if (!el) return { discounts: [] };
        const cfg = JSON.parse(el.textContent);
        return {
          discounts: Array.isArray(cfg.discounts) ? cfg.discounts : [],
        };
      } catch (_) {
        return { discounts: [] };
      }
    }

    function getDiscountCodeCookie() {
      try {
        const match = document.cookie.match(/(?:^|; )discount_code=([^;]*)/);
        return match ? decodeURIComponent(match[1].replace(/\+/g, ' ')).trim().toUpperCase() : '';
      } catch (_) {
        return '';
      }
    }

    function matchedMemberDiscount(discounts, cart) {
      if (!discounts.length || !cart) return null;
      const applied = cart.discount_codes || [];
      const byCode = {};
      let lastApplicable = null;
      let lastAny = null;
      for (let i = 0; i < applied.length; i++) {
        const entry = applied[i];
        if (!entry || !entry.code) continue;
        const code = String(entry.code).trim().toUpperCase();
        for (let j = 0; j < discounts.length; j++) {
          if (discounts[j].code !== code) continue;
          byCode[code] = discounts[j];
          lastAny = discounts[j];
          if (entry.applicable !== false) lastApplicable = discounts[j];
        }
      }
      const cookieCode = getDiscountCodeCookie();
      if (cookieCode && byCode[cookieCode]) return byCode[cookieCode];
      return lastApplicable || lastAny;
    }

    function discountedCents(priceCents, compareCents, matched) {
      if (!matched) return priceCents;
      // Percent-off anchors on retail (compare_at) when the offer's `base` is
      // 'retail'; anchors on the customer's current sale price otherwise.
      // Cents-off always comes off the current price — "$X off" means "$X off
      // what you'd otherwise pay," which shouldn't be gated on retail state.
      const base = matched.base === 'retail' ? compareCents : priceCents;
      if (matched.pct > 0) return Math.max(0, Math.round(base * (1 - matched.pct / 100)));
      if (matched.cents > 0) return Math.max(0, priceCents - matched.cents);
      return priceCents;
    }

    function applyMemberPrices(root, matched) {
      const cards = root.querySelectorAll('[data-sst2-plan-card]');
      cards.forEach((card) => {
        const priceCents = Number(card.dataset.priceCents || 0);
        const compareCents = Number(card.dataset.compareCents || priceCents);
        // The true pre-flash-sale price: a member code replaces an automatic
        // discount at checkout rather than stacking with it (combinesWith:
        // false on both), so its price must be computed off this, not off
        // whatever flash sale has already discounted priceCents/compareCents
        // down to for the no-code default display below.
        const originalPriceCents = Number(card.dataset.originalPriceCents || priceCents);
        const originalCompareCents = Number(card.dataset.originalCompareCents || originalPriceCents);
        const weeks = Number(card.dataset.weeks || 0);
        const mainEl = card.querySelector('[data-sst2-price-main]');
        const compareEl = card.querySelector('[data-sst2-price-compare]');
        const badgeEl = card.querySelector('[data-sst2-member-badge]');
        const flashBadgeEl = card.querySelector('[data-sst2-flash-badge]');
        const sublineEl = card.querySelector('[data-sst2-subline]');

        if (matched) {
          // Checkout doesn't let a member code "replace" an automatic
          // discount outright — when two non-combining discounts could both
          // apply, Shopify keeps whichever is more valuable to the customer
          // (confirmed: a flash sale bigger than a test member code stayed
          // applied at checkout). So compare both candidates instead of
          // assuming the code always wins — showing the code's price
          // unconditionally could display a lower number than checkout
          // actually charges.
          const memberCents = discountedCents(originalPriceCents, originalCompareCents, matched);
          const flashCents = priceCents; // already flash-sale-adjusted, or the true price if no flash is active
          const saleCents = Math.min(memberCents, flashCents);
          const memberWins = saleCents === memberCents;

          if (flashBadgeEl) {
            if (!memberWins && card.dataset.flashActive === 'true') flashBadgeEl.removeAttribute('hidden');
            else flashBadgeEl.setAttribute('hidden', '');
          }
          if (mainEl) mainEl.textContent = moneyFromCents(saleCents);
          if (compareEl) {
            compareEl.textContent = moneyFromCents(originalCompareCents);
            compareEl.removeAttribute('hidden');
          }
          if (badgeEl) {
            if (memberWins) badgeEl.removeAttribute('hidden');
            else badgeEl.setAttribute('hidden', '');
          }
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(saleCents / weeks));
            const save = moneyFromCents(Math.max(0, originalCompareCents - saleCents));
            sublineEl.innerHTML =
              'Equals to ' + weekly + '/week • <span class="sst2-save">Save ' + save + '</span>';
          }
          const title = (card.querySelector('.sst2-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(saleCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(saleCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        } else {
          if (flashBadgeEl) {
            if (card.dataset.flashActive === 'true') flashBadgeEl.removeAttribute('hidden');
            else flashBadgeEl.setAttribute('hidden', '');
          }
          if (mainEl) mainEl.textContent = moneyFromCents(priceCents);
          if (compareEl) {
            if (compareCents > priceCents) {
              compareEl.textContent = moneyFromCents(compareCents);
              compareEl.removeAttribute('hidden');
            } else {
              compareEl.textContent = '';
              compareEl.setAttribute('hidden', '');
            }
          }
          if (badgeEl) badgeEl.setAttribute('hidden', '');
          if (sublineEl && weeks > 0) {
            const weekly = moneyFromCents(Math.round(priceCents / weeks));
            if (compareCents > priceCents) {
              sublineEl.innerHTML =
                'Equals to ' +
                weekly +
                '/week • <span class="sst2-save">Save ' +
                moneyFromCents(compareCents - priceCents) +
                '</span>';
            } else {
              sublineEl.textContent = 'Equals to ' + weekly + '/week';
            }
          }
          const title = (card.querySelector('.sst2-plan-card__title') || {}).textContent || '';
          let sticky = title.trim() + ' · ' + moneyFromCents(priceCents);
          if (weeks > 0) sticky += ' (equal to ' + moneyFromCents(Math.round(priceCents / weeks)) + '/wk)';
          card.dataset.stickyMeta = sticky;
        }
      });

      // Keep ATC sticky meta in sync with the selected card.
      const selected = root.querySelector('[data-sst2-plan-card].is-selected');
      const atc = root.querySelector('[data-sst2-atc]');
      if (selected && atc) atc.dataset.stickyMeta = selected.dataset.stickyMeta || '';
    }

    function initSst2MemberOffer(root) {
      const { discounts } = parseMemberConfig(root);
      if (!discounts.length && !root.hasAttribute('data-sf-member-root')) return;

      function refreshFromCart(cart) {
        applyMemberPrices(root, matchedMemberDiscount(discounts, cart));
      }

      function pullCart() {
        return fetch(sst2CartJsonUrl())
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (cart) refreshFromCart(cart);
          })
          .catch(() => {});
      }

      pullCart();
      document.addEventListener('sf:member-offer', () => pullCart());
      document.addEventListener('cart:updated', (e) => {
        if (e && e.detail && e.detail.cart) refreshFromCart(e.detail.cart);
        else pullCart();
      });
      document.addEventListener('cart:refresh', () => pullCart());
    }

    document.querySelectorAll('.sst2-page[data-section-id]').forEach((root) => {
      initSst2Product(root);
      initSst2MemberOffer(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["safe-seniors-tracker-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function sstCartJsonUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url.replace(/\/?$/, '') + '.js';
        }
      } catch (_) {}
      return '/cart.js';
    }

    function sstCartPageUrl() {
      try {
        if (window.theme && window.theme.routes && window.theme.routes.cart_url) {
          return window.theme.routes.cart_url;
        }
      } catch (_) {}
      return '/cart';
    }

    function initSstProduct(root) {
      const cards = root.querySelectorAll('[data-sst-plan-card]');
      const atcButtons = root.querySelectorAll('[data-sst-atc]');

      // Card selection is cosmetic — each card's own ATC adds its variant.
      cards.forEach((card) => {
        card.addEventListener('click', (e) => {
          if (e.target.closest('[data-sst-atc]')) return;
          cards.forEach((item) => {
            const active = item === card;
            item.classList.toggle('is-selected', active);
            item.setAttribute('aria-checked', String(active));
            item.tabIndex = active ? 0 : -1;
          });
        });
      });

      atcButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
          const variantId = Number(btn.dataset.variantId || 0);
          if (!variantId || btn.disabled) return;

          // Reflect the chosen card as selected.
          const ownCard = btn.closest('[data-sst-plan-card]');
          if (ownCard) {
            cards.forEach((item) => {
              const active = item === ownCard;
              item.classList.toggle('is-selected', active);
              item.setAttribute('aria-checked', String(active));
            });
          }

          const originalLabel = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
          })
            .then((r) => (r.ok ? r.json() : Promise.reject(r)))
            .then(() => fetch(sstCartJsonUrl()))
            .then((r) => r.json())
            .then((cart) => {
              btn.textContent = originalLabel;
              btn.disabled = false;
              document.querySelectorAll('cart-count').forEach((node) => {
                const display =
                  typeof window.fhCartDisplayItemCount === 'function'
                    ? window.fhCartDisplayItemCount(cart)
                    : cart.item_count;
                node.textContent = String(display);
                node.toggleAttribute('hidden', display === 0);
              });
              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
              document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { open: true } }));
              // Take the shopper to the cart page instead of relying on a drawer.
              window.location.href = sstCartPageUrl();
            })
            .catch(() => {
              btn.textContent = 'Try again';
              btn.disabled = false;
              setTimeout(() => { btn.textContent = originalLabel; }, 1200);
            });
        });
      });
    }

    document.querySelectorAll('.sst-page[data-section-id]').forEach(initSstProduct);
  })();

  } catch(e) { console.error(e); }
})();
})();
